const icons = {
  accessibility: {
    icons: [
      'accessible-icon',
      'audio-description',
      'audio-description-slash',
      'braille',
      'brightness',
      'brightness-low',
      'circle-info',
      'circle-question',
      'closed-captioning',
      'closed-captioning-slash',
      'comment-captions',
      'dog-leashed',
      'ear',
      'ear-deaf',
      'ear-listen',
      'eye',
      'eye-low-vision',
      'fingerprint',
      'hands',
      'hands-asl-interpreting',
      'handshake-angle',
      'head-side-heart',
      'keyboard-brightness',
      'keyboard-brightness-low',
      'message-captions',
      'person-cane',
      'person-walking-with-cane',
      'phone-volume',
      'question',
      'square-info',
      'square-question',
      'tty',
      'tty-answer',
      'universal-access',
      'wheelchair',
      'wheelchair-move',
    ],
    label: 'Accessibility',
  },
  alert: {
    icons: [
      'alarm-clock',
      'alarm-exclamation',
      'battery-exclamation',
      'bell',
      'bell-exclamation',
      'bell-on',
      'bell-school-slash',
      'bell-slash',
      'bells',
      'calendar-exclamation',
      'circle-exclamation',
      'circle-exclamation-check',
      'circle-quarters',
      'circle-radiation',
      'cloud-exclamation',
      'cloud-question',
      'comment-exclamation',
      'diamond-exclamation',
      'engine-warning',
      'exclamation',
      'file-exclamation',
      'hexagon-exclamation',
      'light-emergency',
      'light-emergency-on',
      'lightbulb-exclamation',
      'lightbulb-exclamation-on',
      'location-exclamation',
      'message-exclamation',
      'octagon-exclamation',
      'party-bell',
      'party-horn',
      'question',
      'radiation',
      'rotate-exclamation',
      'seal-exclamation',
      'seal-question',
      'sensor',
      'sensor-cloud',
      'sensor-fire',
      'sensor-on',
      'sensor-triangle-exclamation',
      'shield-exclamation',
      'skull-crossbones',
      'square-exclamation',
      'star-exclamation',
      'triangle-exclamation',
      'wifi-exclamation',
      'wind-warning',
    ],
    label: 'Alert',
  },
  alphabet: {
    icons: [
      'a',
      'b',
      'c',
      'circle-a',
      'circle-b',
      'circle-c',
      'circle-d',
      'circle-e',
      'circle-f',
      'circle-g',
      'circle-h',
      'circle-i',
      'circle-j',
      'circle-k',
      'circle-l',
      'circle-m',
      'circle-n',
      'circle-o',
      'circle-p',
      'circle-q',
      'circle-r',
      'circle-s',
      'circle-t',
      'circle-u',
      'circle-v',
      'circle-w',
      'circle-x',
      'circle-y',
      'circle-z',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      'square-a',
      'square-b',
      'square-c',
      'square-d',
      'square-e',
      'square-f',
      'square-g',
      'square-h',
      'square-i',
      'square-j',
      'square-k',
      'square-l',
      'square-m',
      'square-n',
      'square-o',
      'square-p',
      'square-q',
      'square-r',
      'square-s',
      'square-t',
      'square-u',
      'square-v',
      'square-w',
      'square-x',
      'square-y',
      'square-z',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    label: 'Alphabet',
  },
  animals: {
    icons: [
      'alicorn',
      'badger-honey',
      'bat',
      'bee',
      'bird',
      'bugs',
      'cat',
      'cat-space',
      'cow',
      'crab',
      'crow',
      'deer',
      'deer-rudolph',
      'dog',
      'dog-leashed',
      'dolphin',
      'dove',
      'dragon',
      'duck',
      'elephant',
      'feather',
      'feather-pointed',
      'fish',
      'fish-bones',
      'fish-fins',
      'frog',
      'hippo',
      'horse',
      'horse-head',
      'horse-saddle',
      'kiwi-bird',
      'lobster',
      'locust',
      'monkey',
      'mosquito',
      'mouse-field',
      'narwhal',
      'otter',
      'paw',
      'paw-claws',
      'paw-simple',
      'pegasus',
      'pig',
      'rabbit',
      'rabbit-running',
      'ram',
      'sheep',
      'shield-cat',
      'shield-dog',
      'shrimp',
      'skull-cow',
      'snake',
      'spider',
      'spider-black-widow',
      'squid',
      'squirrel',
      'teddy-bear',
      'turtle',
      'unicorn',
      'whale',
      'worm',
    ],
    label: 'Animals',
  },
  arrows: {
    icons: [
      'angle-down',
      'angle-left',
      'angle-right',
      'angle-up',
      'angles-down',
      'angles-left',
      'angles-right',
      'angles-up',
      'arrow-down',
      'arrow-down-1-9',
      'arrow-down-9-1',
      'arrow-down-a-z',
      'arrow-down-arrow-up',
      'arrow-down-big-small',
      'arrow-down-from-dotted-line',
      'arrow-down-from-line',
      'arrow-down-left',
      'arrow-down-left-and-arrow-up-right-to-center',
      'arrow-down-long',
      'arrow-down-right',
      'arrow-down-short-wide',
      'arrow-down-small-big',
      'arrow-down-square-triangle',
      'arrow-down-to-arc',
      'arrow-down-to-bracket',
      'arrow-down-to-dotted-line',
      'arrow-down-to-line',
      'arrow-down-to-square',
      'arrow-down-triangle-square',
      'arrow-down-up-across-line',
      'arrow-down-up-lock',
      'arrow-down-wide-short',
      'arrow-down-z-a',
      'arrow-left',
      'arrow-left-from-line',
      'arrow-left-long',
      'arrow-left-long-to-line',
      'arrow-left-to-line',
      'arrow-pointer',
      'arrow-right',
      'arrow-right-arrow-left',
      'arrow-right-from-arc',
      'arrow-right-from-bracket',
      'arrow-right-from-line',
      'arrow-right-long',
      'arrow-right-long-to-line',
      'arrow-right-to-arc',
      'arrow-right-to-bracket',
      'arrow-right-to-line',
      'arrow-rotate-left',
      'arrow-rotate-right',
      'arrow-trend-down',
      'arrow-trend-up',
      'arrow-turn-down',
      'arrow-turn-down-left',
      'arrow-turn-down-right',
      'arrow-turn-up',
      'arrow-up',
      'arrow-up-1-9',
      'arrow-up-9-1',
      'arrow-up-a-z',
      'arrow-up-arrow-down',
      'arrow-up-big-small',
      'arrow-up-from-arc',
      'arrow-up-from-bracket',
      'arrow-up-from-dotted-line',
      'arrow-up-from-line',
      'arrow-up-from-square',
      'arrow-up-left',
      'arrow-up-left-from-circle',
      'arrow-up-long',
      'arrow-up-right',
      'arrow-up-right-and-arrow-down-left-from-center',
      'arrow-up-right-dots',
      'arrow-up-right-from-square',
      'arrow-up-short-wide',
      'arrow-up-small-big',
      'arrow-up-square-triangle',
      'arrow-up-to-dotted-line',
      'arrow-up-to-line',
      'arrow-up-triangle-square',
      'arrow-up-wide-short',
      'arrow-up-z-a',
      'arrows-cross',
      'arrows-down-to-line',
      'arrows-from-dotted-line',
      'arrows-from-line',
      'arrows-left-right',
      'arrows-left-right-to-line',
      'arrows-maximize',
      'arrows-minimize',
      'arrows-repeat',
      'arrows-repeat-1',
      'arrows-retweet',
      'arrows-rotate',
      'arrows-spin',
      'arrows-split-up-and-left',
      'arrows-to-circle',
      'arrows-to-dot',
      'arrows-to-dotted-line',
      'arrows-to-eye',
      'arrows-to-line',
      'arrows-turn-right',
      'arrows-turn-to-dots',
      'arrows-up-down',
      'arrows-up-down-left-right',
      'arrows-up-to-line',
      'caret-down',
      'caret-left',
      'caret-right',
      'caret-up',
      'chevron-down',
      'chevron-left',
      'chevron-right',
      'chevron-up',
      'chevrons-down',
      'chevrons-left',
      'chevrons-right',
      'chevrons-up',
      'circle-arrow-down',
      'circle-arrow-down-left',
      'circle-arrow-down-right',
      'circle-arrow-left',
      'circle-arrow-right',
      'circle-arrow-up',
      'circle-arrow-up-left',
      'circle-arrow-up-right',
      'circle-caret-down',
      'circle-caret-left',
      'circle-caret-right',
      'circle-caret-up',
      'circle-chevron-down',
      'circle-chevron-left',
      'circle-chevron-right',
      'circle-chevron-up',
      'circle-down',
      'circle-down-left',
      'circle-down-right',
      'circle-left',
      'circle-right',
      'circle-up',
      'circle-up-left',
      'circle-up-right',
      'clock-rotate-left',
      'cloud-arrow-down',
      'cloud-arrow-up',
      'down',
      'down-from-dotted-line',
      'down-from-line',
      'down-left',
      'down-left-and-up-right-to-center',
      'down-long',
      'down-right',
      'down-to-bracket',
      'down-to-dotted-line',
      'down-to-line',
      'download',
      'inbox-in',
      'inbox-out',
      'left',
      'left-from-line',
      'left-long',
      'left-long-to-line',
      'left-right',
      'left-to-line',
      'location-arrow',
      'maximize',
      'merge',
      'recycle',
      'repeat',
      'repeat-1',
      'reply',
      'reply-all',
      'retweet',
      'right',
      'right-from-bracket',
      'right-from-line',
      'right-left',
      'right-long',
      'right-long-to-line',
      'right-to-bracket',
      'right-to-line',
      'rotate',
      'rotate-left',
      'rotate-right',
      'share',
      'share-all',
      'share-from-square',
      'shuffle',
      'sort',
      'sort-down',
      'sort-up',
      'split',
      'square-arrow-down',
      'square-arrow-down-left',
      'square-arrow-down-right',
      'square-arrow-left',
      'square-arrow-right',
      'square-arrow-up',
      'square-arrow-up-left',
      'square-arrow-up-right',
      'square-caret-down',
      'square-caret-left',
      'square-caret-right',
      'square-caret-up',
      'square-chevron-down',
      'square-chevron-left',
      'square-chevron-right',
      'square-chevron-up',
      'square-down',
      'square-down-left',
      'square-down-right',
      'square-left',
      'square-right',
      'square-up',
      'square-up-left',
      'square-up-right',
      'turn-down',
      'turn-down-left',
      'turn-down-right',
      'turn-up',
      'up',
      'up-down',
      'up-down-left-right',
      'up-from-bracket',
      'up-from-dotted-line',
      'up-from-line',
      'up-left',
      'up-long',
      'up-right',
      'up-right-and-down-left-from-center',
      'up-right-from-square',
      'up-to-dotted-line',
      'up-to-line',
      'upload',
    ],
    label: 'Arrows',
  },
  astronomy: {
    icons: [
      'alien',
      'cat-space',
      'comet',
      'eclipse',
      'galaxy',
      'globe',
      'meteor',
      'moon',
      'moon-over-sun',
      'moon-stars',
      'planet-moon',
      'planet-ringed',
      'radar',
      'satellite',
      'satellite-dish',
      'shuttle-space',
      'solar-system',
      'star-shooting',
      'stars',
      'telescope',
      'ufo',
      'ufo-beam',
      'user-alien',
      'user-astronaut',
    ],
    label: 'Astronomy',
  },
  automotive: {
    icons: [
      'brake-warning',
      'bus',
      'bus-simple',
      'car',
      'car-battery',
      'car-bolt',
      'car-building',
      'car-bump',
      'car-burst',
      'car-bus',
      'car-circle-bolt',
      'car-garage',
      'car-mirrors',
      'car-on',
      'car-rear',
      'car-side',
      'car-side-bolt',
      'car-tilt',
      'car-tunnel',
      'car-wash',
      'car-wrench',
      'caravan',
      'caravan-simple',
      'cars',
      'charging-station',
      'engine',
      'engine-warning',
      'flux-capacitor',
      'garage',
      'garage-car',
      'garage-open',
      'gas-pump',
      'gas-pump-slash',
      'gauge',
      'gauge-circle-bolt',
      'gauge-circle-minus',
      'gauge-circle-plus',
      'gauge-high',
      'gauge-low',
      'gauge-max',
      'gauge-min',
      'gauge-simple',
      'gauge-simple-high',
      'gauge-simple-low',
      'gauge-simple-max',
      'gauge-simple-min',
      'moped',
      'motorcycle',
      'oil-can',
      'oil-can-drip',
      'oil-temperature',
      'pump',
      'rv',
      'spray-can-sparkles',
      'steering-wheel',
      'tank-water',
      'taxi',
      'tire',
      'tire-flat',
      'tire-pressure-warning',
      'tire-rugged',
      'trailer',
      'truck',
      'truck-bolt',
      'truck-field',
      'truck-field-un',
      'truck-medical',
      'truck-monster',
      'truck-pickup',
      'van-shuttle',
      'wagon-covered',
    ],
    label: 'Automotive',
  },
  buildings: {
    icons: [
      'apartment',
      'archway',
      'arrow-right-to-city',
      'bridge-suspension',
      'building',
      'building-circle-arrow-right',
      'building-circle-check',
      'building-circle-exclamation',
      'building-circle-xmark',
      'building-columns',
      'building-flag',
      'building-lock',
      'building-ngo',
      'building-shield',
      'building-un',
      'building-user',
      'building-wheat',
      'buildings',
      'cabin',
      'campground',
      'car-building',
      'castle',
      'chimney',
      'church',
      'city',
      'container-storage',
      'dungeon',
      'farm',
      'fence',
      'ferris-wheel',
      'fort',
      'garage',
      'garage-car',
      'garage-open',
      'gopuram',
      'hospital',
      'hospital-user',
      'hospitals',
      'hotel',
      'house',
      'house-blank',
      'house-building',
      'house-chimney',
      'house-chimney-blank',
      'house-chimney-crack',
      'house-chimney-medical',
      'house-chimney-window',
      'house-circle-check',
      'house-circle-exclamation',
      'house-circle-xmark',
      'house-crack',
      'house-day',
      'house-fire',
      'house-flag',
      'house-lock',
      'house-medical',
      'house-medical-circle-check',
      'house-medical-circle-exclamation',
      'house-medical-circle-xmark',
      'house-medical-flag',
      'house-night',
      'house-tree',
      'house-turret',
      'house-water',
      'house-window',
      'igloo',
      'industry',
      'industry-windows',
      'kaaba',
      'landmark',
      'landmark-dome',
      'landmark-flag',
      'monument',
      'mosque',
      'mountain-city',
      'oil-well',
      'place-of-worship',
      'roller-coaster',
      'school',
      'school-circle-check',
      'school-circle-exclamation',
      'school-circle-xmark',
      'school-flag',
      'school-lock',
      'shop',
      'shop-lock',
      'store',
      'store-lock',
      'synagogue',
      'tent',
      'tent-arrow-down-to-line',
      'tent-arrow-left-right',
      'tent-arrow-turn-left',
      'tent-arrows-down',
      'tents',
      'toilet-portable',
      'toilets-portable',
      'torii-gate',
      'tower-observation',
      'tree-city',
      'vihara',
      'warehouse',
      'warehouse-full',
    ],
    label: 'Buildings',
  },
  business: {
    icons: [
      'address-book',
      'address-card',
      'arrows-spin',
      'arrows-to-dot',
      'arrows-to-eye',
      'badge',
      'badge-check',
      'badge-dollar',
      'badge-percent',
      'bars-progress',
      'bars-staggered',
      'book',
      'book-section',
      'box-archive',
      'boxes-packing',
      'brain-arrow-curved-right',
      'briefcase',
      'briefcase-arrow-right',
      'briefcase-blank',
      'building',
      'bullhorn',
      'bullseye',
      'business-time',
      'cabinet-filing',
      'cake-candles',
      'calculator',
      'calendar',
      'calendar-days',
      'certificate',
      'chart-line',
      'chart-line-down',
      'chart-line-up',
      'chart-pie',
      'chart-pie-simple',
      'chart-pyramid',
      'chart-simple',
      'chart-simple-horizontal',
      'chart-tree-map',
      'chart-user',
      'city',
      'clipboard',
      'clipboard-question',
      'cloud-word',
      'coffee-pot',
      'compass',
      'computer-classic',
      'copy',
      'copyright',
      'diagram-venn',
      'envelope',
      'envelope-circle-check',
      'envelope-dot',
      'envelope-open',
      'envelopes',
      'eraser',
      'fax',
      'file',
      'file-chart-column',
      'file-chart-pie',
      'file-circle-info',
      'file-circle-plus',
      'file-lines',
      'file-spreadsheet',
      'file-user',
      'floppy-disk',
      'floppy-disk-circle-arrow-right',
      'floppy-disk-circle-xmark',
      'folder',
      'folder-arrow-down',
      'folder-arrow-up',
      'folder-minus',
      'folder-open',
      'folder-plus',
      'folder-tree',
      'folder-xmark',
      'folders',
      'glasses',
      'globe',
      'highlighter',
      'house-laptop',
      'inbox-full',
      'inboxes',
      'industry',
      'industry-windows',
      'keynote',
      'lamp-desk',
      'landmark',
      'laptop-file',
      'list-check',
      'list-dropdown',
      'list-radio',
      'list-timeline',
      'list-tree',
      'magnifying-glass-arrow-right',
      'magnifying-glass-chart',
      'marker',
      'money-check-dollar-pen',
      'money-check-pen',
      'mug-saucer',
      'network-wired',
      'note-sticky',
      'notebook',
      'paperclip',
      'paperclip-vertical',
      'paste',
      'pen',
      'pen-clip',
      'pen-fancy',
      'pen-nib',
      'pen-nib-slash',
      'pen-to-square',
      'pencil',
      'percent',
      'person-chalkboard',
      'phone',
      'phone-flip',
      'phone-intercom',
      'phone-office',
      'phone-slash',
      'phone-volume',
      'podium',
      'presentation-screen',
      'print',
      'print-magnifying-glass',
      'print-slash',
      'projector',
      'rectangle-pro',
      'registered',
      'router',
      'scale-balanced',
      'scale-unbalanced',
      'scale-unbalanced-flip',
      'scanner-image',
      'scissors',
      'shredder',
      'signature',
      'signature-lock',
      'signature-slash',
      'sitemap',
      'slot-machine',
      'socks',
      'square-envelope',
      'square-kanban',
      'square-pen',
      'square-phone',
      'square-phone-flip',
      'square-poll-horizontal',
      'square-poll-vertical',
      'stapler',
      'table',
      'table-columns',
      'table-layout',
      'table-pivot',
      'table-rows',
      'table-tree',
      'tag',
      'tags',
      'thumbtack',
      'timeline',
      'timeline-arrow',
      'trademark',
      'user-hair-mullet',
      'user-tie-hair',
      'user-tie-hair-long',
      'vault',
      'wallet',
    ],
    label: 'Business',
  },
  camping: {
    icons: [
      'acorn',
      'axe',
      'backpack',
      'bench-tree',
      'binoculars',
      'boot',
      'bottle-water',
      'bucket',
      'cabin',
      'campfire',
      'campground',
      'caravan',
      'caravan-simple',
      'cauldron',
      'compass',
      'faucet',
      'faucet-drip',
      'fire',
      'fire-burner',
      'fire-flame-curved',
      'fire-smoke',
      'fishing-rod',
      'flashlight',
      'frog',
      'grill',
      'grill-fire',
      'grill-hot',
      'kit-medical',
      'map',
      'map-location',
      'map-location-dot',
      'mattress-pillow',
      'mosquito',
      'mosquito-net',
      'mountain',
      'mountain-sun',
      'mountains',
      'people-roof',
      'person-biking-mountain',
      'person-hiking',
      'person-shelter',
      'pickaxe',
      'route',
      'rv',
      'shish-kebab',
      'shovel',
      'signs-post',
      'squirrel',
      'sunrise',
      'sunset',
      'table-picnic',
      'tarp',
      'tarp-droplet',
      'teddy-bear',
      'tent',
      'tent-arrow-down-to-line',
      'tent-arrow-left-right',
      'tent-arrow-turn-left',
      'tent-arrows-down',
      'tents',
      'toilet-paper',
      'toilet-paper-blank',
      'trailer',
      'tree',
      'tree-deciduous',
      'tree-large',
      'trees',
    ],
    label: 'Camping',
  },
  charity: {
    icons: [
      'book-heart',
      'box-dollar',
      'box-heart',
      'circle-dollar',
      'circle-dollar-to-slot',
      'circle-heart',
      'dollar-sign',
      'dove',
      'gift',
      'globe',
      'hand-heart',
      'hand-holding-dollar',
      'hand-holding-droplet',
      'hand-holding-hand',
      'hand-holding-heart',
      'hand-holding-seedling',
      'hands-holding-child',
      'hands-holding-circle',
      'hands-holding-dollar',
      'hands-holding-heart',
      'handshake',
      'handshake-angle',
      'handshake-simple',
      'heart',
      'house-chimney-heart',
      'house-heart',
      'leaf',
      'leaf-heart',
      'money-check-dollar-pen',
      'money-check-pen',
      'parachute-box',
      'piggy-bank',
      'ribbon',
      'seedling',
      'square-dollar',
      'square-heart',
    ],
    label: 'Charity',
  },
  'charts-diagrams': {
    icons: [
      'bars-progress',
      'chart-area',
      'chart-bar',
      'chart-bullet',
      'chart-candlestick',
      'chart-column',
      'chart-gantt',
      'chart-line',
      'chart-line-down',
      'chart-line-up',
      'chart-mixed',
      'chart-network',
      'chart-pie',
      'chart-pie-simple',
      'chart-pyramid',
      'chart-radar',
      'chart-scatter',
      'chart-scatter-3d',
      'chart-scatter-bubble',
      'chart-simple',
      'chart-simple-horizontal',
      'chart-tree-map',
      'chart-user',
      'chart-waterfall',
      'circle-half-stroke',
      'circle-quarter-stroke',
      'circle-three-quarters-stroke',
      'diagram-cells',
      'diagram-lean-canvas',
      'diagram-nested',
      'diagram-next',
      'diagram-predecessor',
      'diagram-previous',
      'diagram-project',
      'diagram-sankey',
      'diagram-subtask',
      'diagram-successor',
      'diagram-venn',
      'file-chart-column',
      'file-chart-pie',
      'square-kanban',
      'square-poll-horizontal',
      'square-poll-vertical',
    ],
    label: 'Charts + Diagrams',
  },
  childhood: {
    icons: [
      'apple-whole',
      'baby',
      'baby-carriage',
      'backpack',
      'ball-pile',
      'balloon',
      'balloons',
      'baseball-bat-ball',
      'basketball-hoop',
      'bath',
      'bell-school',
      'bell-school-slash',
      'block',
      'block-question',
      'bowl-soft-serve',
      'bucket',
      'cake-candles',
      'cake-slice',
      'candy',
      'candy-bar',
      'child',
      'child-dress',
      'child-reaching',
      'children',
      'cookie',
      'cookie-bite',
      'cubes-stacked',
      'cupcake',
      'duck',
      'family',
      'family-dress',
      'family-pants',
      'ferris-wheel',
      'flashlight',
      'game-console-handheld',
      'gamepad',
      'gamepad-modern',
      'globe-snow',
      'gun-squirt',
      'hands-holding-child',
      'ice-cream',
      'lollipop',
      'mitten',
      'person-biking',
      'person-breastfeeding',
      'person-sledding',
      'pinata',
      'pool-8-ball',
      'popsicle',
      'pretzel',
      'puzzle',
      'puzzle-piece',
      'robot',
      'roller-coaster',
      'school',
      'shapes',
      'snowman',
      'snowman-head',
      'soft-serve',
      'teddy-bear',
      'thought-bubble',
      'tricycle',
    ],
    label: 'Childhood',
  },
  'clothing-fashion': {
    icons: [
      'boot',
      'boot-heeled',
      'clothes-hanger',
      'ear-muffs',
      'glasses',
      'glasses-round',
      'graduation-cap',
      'hat-cowboy',
      'hat-cowboy-side',
      'hat-santa',
      'hat-winter',
      'hat-witch',
      'hat-wizard',
      'hood-cloak',
      'ice-skate',
      'mitten',
      'mustache',
      'pipe-smoking',
      'reel',
      'scarf',
      'shirt',
      'shirt-long-sleeve',
      'shirt-running',
      'shirt-tank-top',
      'shoe-prints',
      'ski-boot',
      'socks',
      'stocking',
      'sunglasses',
      'uniform-martial-arts',
      'user-tie',
      'vest',
      'vest-patches',
    ],
    label: 'Clothing + Fashion',
  },
  coding: {
    icons: [
      'ban-bug',
      'barcode',
      'bars',
      'bars-filter',
      'bars-sort',
      'bars-staggered',
      'bath',
      'binary',
      'binary-circle-check',
      'binary-lock',
      'binary-slash',
      'box-archive',
      'bracket-curly',
      'bracket-curly-right',
      'bracket-round',
      'bracket-round-right',
      'bracket-square',
      'bracket-square-right',
      'brackets-curly',
      'brackets-round',
      'brackets-square',
      'brain-circuit',
      'browser',
      'browsers',
      'bug',
      'bug-slash',
      'circle-nodes',
      'code',
      'code-branch',
      'code-commit',
      'code-compare',
      'code-fork',
      'code-merge',
      'code-pull-request',
      'code-pull-request-closed',
      'code-pull-request-draft',
      'code-simple',
      'cube',
      'cubes',
      'diagram-project',
      'file',
      'file-code',
      'file-lines',
      'filter',
      'fire-extinguisher',
      'folder',
      'folder-open',
      'font-awesome',
      'gears',
      'key-skeleton-left-right',
      'keyboard',
      'laptop-code',
      'laptop-mobile',
      'merge',
      'microchip',
      'mug-saucer',
      'network-wired',
      'notdef',
      'octagon-exclamation',
      'qrcode',
      'rectangle-code',
      'rectangle-terminal',
      'rectangle-xmark',
      'shield',
      'shield-check',
      'shield-halved',
      'sidebar',
      'sidebar-flip',
      'sitemap',
      'split',
      'square-code',
      'square-terminal',
      'terminal',
      'user-secret',
      'webhook',
      'window',
      'window-flip',
      'window-maximize',
      'window-minimize',
      'window-restore',
      'wrench-simple',
    ],
    label: 'Coding',
  },
  communication: {
    icons: [
      'address-book',
      'address-card',
      'at',
      'blender-phone',
      'bluetooth-b',
      'bullhorn',
      'circle-envelope',
      'circle-phone',
      'circle-phone-flip',
      'circle-phone-hangup',
      'comment',
      'comment-arrow-down',
      'comment-arrow-up',
      'comment-arrow-up-right',
      'comment-captions',
      'comment-check',
      'comment-code',
      'comment-dots',
      'comment-exclamation',
      'comment-heart',
      'comment-image',
      'comment-lines',
      'comment-medical',
      'comment-middle',
      'comment-middle-top',
      'comment-minus',
      'comment-music',
      'comment-pen',
      'comment-plus',
      'comment-question',
      'comment-quote',
      'comment-slash',
      'comment-smile',
      'comment-sms',
      'comment-text',
      'comment-xmark',
      'comments',
      'comments-question',
      'comments-question-check',
      'crystal-ball',
      'ear-listen',
      'envelope',
      'envelope-circle-check',
      'envelope-dot',
      'envelope-open',
      'envelopes',
      'face-awesome',
      'face-frown',
      'face-meh',
      'face-smile',
      'face-smile-plus',
      'fax',
      'hands-asl-interpreting',
      'hundred-points',
      'icons',
      'inbox',
      'inbox-in',
      'inbox-out',
      'language',
      'mailbox',
      'mailbox-flag-up',
      'message',
      'message-arrow-down',
      'message-arrow-up',
      'message-arrow-up-right',
      'message-bot',
      'message-check',
      'message-code',
      'message-dots',
      'message-exclamation',
      'message-heart',
      'message-image',
      'message-lines',
      'message-medical',
      'message-middle',
      'message-middle-top',
      'message-minus',
      'message-pen',
      'message-plus',
      'message-question',
      'message-quote',
      'message-slash',
      'message-smile',
      'message-sms',
      'message-text',
      'message-xmark',
      'messages',
      'messages-question',
      'microphone',
      'microphone-lines',
      'microphone-lines-slash',
      'microphone-slash',
      'mobile',
      'mobile-button',
      'mobile-notch',
      'mobile-retro',
      'mobile-screen',
      'mobile-screen-button',
      'paper-plane',
      'paper-plane-top',
      'phone',
      'phone-arrow-down-left',
      'phone-arrow-right',
      'phone-arrow-up-right',
      'phone-flip',
      'phone-hangup',
      'phone-intercom',
      'phone-missed',
      'phone-plus',
      'phone-slash',
      'phone-volume',
      'phone-xmark',
      'poo',
      'quote-left',
      'quote-right',
      'square-envelope',
      'square-phone',
      'square-phone-flip',
      'square-phone-hangup',
      'square-quote',
      'square-rss',
      'symbols',
      'thought-bubble',
      'tower-cell',
      'tty',
      'tty-answer',
      'video',
      'video-plus',
      'video-slash',
      'voicemail',
      'walkie-talkie',
    ],
    label: 'Communication',
  },
  connectivity: {
    icons: [
      'bluetooth',
      'circle-nodes',
      'cloud',
      'cloud-arrow-down',
      'cloud-arrow-up',
      'cloud-check',
      'cloud-exclamation',
      'cloud-minus',
      'cloud-plus',
      'cloud-question',
      'cloud-slash',
      'cloud-xmark',
      'ethernet',
      'globe',
      'house-signal',
      'link-horizontal',
      'link-horizontal-slash',
      'mobile-signal',
      'mobile-signal-out',
      'nfc-signal',
      'rss',
      'satellite-dish',
      'signal',
      'signal-bars',
      'signal-bars-fair',
      'signal-bars-good',
      'signal-bars-slash',
      'signal-bars-weak',
      'signal-fair',
      'signal-good',
      'signal-slash',
      'signal-stream',
      'signal-stream-slash',
      'signal-strong',
      'signal-weak',
      'tower-broadcast',
      'tower-cell',
      'wifi',
      'wifi-exclamation',
      'wifi-fair',
      'wifi-weak',
    ],
    label: 'Connectivity',
  },
  construction: {
    icons: [
      'angle',
      'angle-90',
      'arrow-up-from-ground-water',
      'axe',
      'block',
      'block-brick',
      'bore-hole',
      'brush',
      'bucket',
      'compass-drafting',
      'dumpster',
      'dumpster-fire',
      'forklift',
      'frame',
      'grate',
      'grate-droplet',
      'hammer',
      'hammer-crash',
      'helmet-safety',
      'hose',
      'hose-reel',
      'mound',
      'paint-roller',
      'pen-ruler',
      'pencil',
      'person-digging',
      'reel',
      'ruler',
      'ruler-combined',
      'ruler-horizontal',
      'ruler-triangle',
      'ruler-vertical',
      'screwdriver',
      'screwdriver-wrench',
      'sheet-plastic',
      'shovel',
      'shovel-snow',
      'tarp',
      'tarp-droplet',
      'toilet-portable',
      'toilets-portable',
      'toolbox',
      'traffic-cone',
      'triangle-person-digging',
      'trowel',
      'trowel-bricks',
      'truck-container',
      'truck-pickup',
      'user-helmet-safety',
      'wrench',
      'wrench-simple',
    ],
    label: 'Construction',
  },
  design: {
    icons: [
      'angle',
      'angle-90',
      'ball-pile',
      'bezier-curve',
      'book-font',
      'bring-forward',
      'bring-front',
      'broom-wide',
      'brush',
      'camera-polaroid',
      'circle-dashed',
      'circle-half-stroke',
      'circle-nodes',
      'circle-quarter-stroke',
      'circle-three-quarters-stroke',
      'clone',
      'columns-3',
      'compass-drafting',
      'copy',
      'crop',
      'crop-simple',
      'crosshairs',
      'crosshairs-simple',
      'cube',
      'cubes',
      'distribute-spacing-horizontal',
      'distribute-spacing-vertical',
      'draw-circle',
      'draw-polygon',
      'draw-square',
      'droplet',
      'droplet-slash',
      'eraser',
      'eye',
      'eye-dropper',
      'eye-dropper-full',
      'eye-dropper-half',
      'eye-slash',
      'fill',
      'fill-drip',
      'floppy-disk',
      'font-awesome',
      'frame',
      'gallery-thumbnails',
      'grid',
      'grid-2',
      'grid-2-plus',
      'grid-4',
      'grid-5',
      'grid-dividers',
      'highlighter',
      'highlighter-line',
      'icons',
      'image-polaroid',
      'lasso',
      'lasso-sparkles',
      'layer-group',
      'layer-minus',
      'layer-plus',
      'lines-leaning',
      'marker',
      'notebook',
      'object-exclude',
      'object-group',
      'object-intersect',
      'object-subtract',
      'object-ungroup',
      'object-union',
      'objects-align-bottom',
      'objects-align-center-horizontal',
      'objects-align-center-vertical',
      'objects-align-left',
      'objects-align-right',
      'objects-align-top',
      'objects-column',
      'paint-roller',
      'paintbrush',
      'paintbrush-fine',
      'paintbrush-pencil',
      'palette',
      'paste',
      'pen',
      'pen-circle',
      'pen-clip',
      'pen-fancy',
      'pen-nib',
      'pen-nib-slash',
      'pen-ruler',
      'pen-to-square',
      'pencil',
      'pencil-mechanical',
      'rectangle-pro',
      'rectangles-mixed',
      'ruler-combined',
      'ruler-horizontal',
      'ruler-vertical',
      'scanner-image',
      'scissors',
      'scribble',
      'send-back',
      'send-backward',
      'sparkle',
      'splotch',
      'spray-can',
      'square-dashed',
      'square-dashed-circle-plus',
      'stamp',
      'stapler',
      'swatchbook',
      'symbols',
      'vector-circle',
      'vector-polygon',
      'vector-square',
      'wand-magic',
      'wand-magic-sparkles',
      'wrench-simple',
    ],
    label: 'Design',
  },
  'devices-hardware': {
    icons: [
      'album',
      'album-circle-plus',
      'album-circle-user',
      'blender-phone',
      'camera',
      'camera-retro',
      'camera-web',
      'camera-web-slash',
      'car-battery',
      'compact-disc',
      'computer',
      'computer-classic',
      'computer-mouse',
      'computer-mouse-scrollwheel',
      'computer-speaker',
      'database',
      'desktop',
      'desktop-arrow-down',
      'disc-drive',
      'display',
      'display-arrow-down',
      'display-code',
      'display-medical',
      'display-slash',
      'download',
      'engine',
      'ethernet',
      'fax',
      'flashlight',
      'floppy-disk',
      'floppy-disk-pen',
      'floppy-disks',
      'flux-capacitor',
      'game-console-handheld',
      'game-console-handheld-crank',
      'gamepad',
      'gamepad-modern',
      'hard-drive',
      'headphones',
      'house-laptop',
      'keyboard',
      'keyboard-down',
      'keyboard-left',
      'laptop',
      'laptop-arrow-down',
      'laptop-file',
      'laptop-mobile',
      'laptop-slash',
      'memory',
      'meter',
      'microchip',
      'microchip-ai',
      'mobile',
      'mobile-button',
      'mobile-notch',
      'mobile-retro',
      'mobile-screen',
      'mobile-screen-button',
      'mobile-signal',
      'mobile-signal-out',
      'mp3-player',
      'phone-office',
      'plug',
      'power-off',
      'print',
      'projector',
      'router',
      'satellite',
      'satellite-dish',
      'scanner-image',
      'sd-card',
      'sd-cards',
      'server',
      'shredder',
      'sim-card',
      'sim-cards',
      'speaker',
      'speakers',
      'tablet',
      'tablet-button',
      'tablet-screen',
      'tablet-screen-button',
      'tachograph-digital',
      'tv',
      'tv-music',
      'tv-retro',
      'typewriter',
      'upload',
      'usb-drive',
      'walkie-talkie',
      'watch-calculator',
    ],
    label: 'Devices + Hardware',
  },
  disaster: {
    icons: [
      'biohazard',
      'bugs',
      'burst',
      'child-combatant',
      'circle-radiation',
      'cloud-bolt',
      'cloud-showers-heavy',
      'cloud-showers-water',
      'heat',
      'helmet-un',
      'hill-avalanche',
      'hill-rockslide',
      'house-chimney-crack',
      'house-crack',
      'house-fire',
      'house-flood-water',
      'house-flood-water-circle-arrow-right',
      'house-tsunami',
      'house-water',
      'hurricane',
      'locust',
      'mosquito',
      'person-drowning',
      'person-rifle',
      'person-walking-arrow-loop-left',
      'person-walking-arrow-right',
      'person-walking-dashed-line-arrow-right',
      'plant-wilt',
      'radiation',
      'snowflake',
      'sun-plant-wilt',
      'temperature-arrow-down',
      'temperature-arrow-up',
      'tornado',
      'volcano',
      'wheat-awn-circle-exclamation',
      'wind',
      'wind-warning',
      'worm',
      'xmarks-lines',
    ],
    label: 'Disaster + Crisis',
  },
  editing: {
    icons: [
      'arrows-rotate',
      'bandage',
      'bars',
      'bars-filter',
      'bars-sort',
      'brush',
      'chart-simple',
      'check',
      'check-double',
      'circle-check',
      'circle-dashed',
      'circle-ellipsis',
      'circle-ellipsis-vertical',
      'circle-half-stroke',
      'circle-quarter-stroke',
      'circle-three-quarters-stroke',
      'circle-trash',
      'command',
      'crop',
      'crop-simple',
      'cube',
      'dash',
      'delete-left',
      'delete-right',
      'diagram-venn',
      'dial',
      'dial-high',
      'dial-low',
      'dial-max',
      'dial-med',
      'dial-med-low',
      'dial-min',
      'dial-off',
      'distribute-spacing-horizontal',
      'distribute-spacing-vertical',
      'ellipsis',
      'ellipsis-stroke',
      'ellipsis-stroke-vertical',
      'ellipsis-vertical',
      'eye-dropper',
      'eye-dropper-full',
      'eye-dropper-half',
      'eye-slash',
      'gallery-thumbnails',
      'grid',
      'grid-2',
      'grid-2-plus',
      'grid-4',
      'grid-5',
      'grid-dividers',
      'grid-horizontal',
      'grip',
      'grip-dots',
      'grip-dots-vertical',
      'grip-lines',
      'grip-lines-vertical',
      'grip-vertical',
      'hexagon-check',
      'lasso',
      'lasso-sparkles',
      'link',
      'link-simple',
      'link-simple-slash',
      'link-slash',
      'minus',
      'objects-align-bottom',
      'objects-align-center-horizontal',
      'objects-align-center-vertical',
      'objects-align-left',
      'objects-align-right',
      'objects-align-top',
      'objects-column',
      'octagon-check',
      'paintbrush',
      'paintbrush-fine',
      'paintbrush-pencil',
      'pen',
      'pen-circle',
      'pen-clip',
      'pen-clip-slash',
      'pen-fancy',
      'pen-fancy-slash',
      'pen-field',
      'pen-line',
      'pen-nib',
      'pen-nib-slash',
      'pen-paintbrush',
      'pen-ruler',
      'pen-slash',
      'pen-swirl',
      'pen-to-square',
      'pencil',
      'pencil-mechanical',
      'pencil-slash',
      'plus',
      'plus-large',
      'rabbit-running',
      'rectangles-mixed',
      'rotate',
      'scissors',
      'scribble',
      'signature',
      'signature-lock',
      'signature-slash',
      'sliders',
      'sliders-simple',
      'sliders-up',
      'square-check',
      'square-dashed',
      'square-dashed-circle-plus',
      'square-ellipsis',
      'square-ellipsis-vertical',
      'square-pen',
      'trash',
      'trash-arrow-up',
      'trash-can',
      'trash-can-arrow-up',
      'trash-can-check',
      'trash-can-clock',
      'trash-can-list',
      'trash-can-plus',
      'trash-can-slash',
      'trash-can-undo',
      'trash-can-xmark',
      'trash-check',
      'trash-clock',
      'trash-list',
      'trash-plus',
      'trash-slash',
      'trash-undo',
      'trash-xmark',
      'turtle',
      'wand-magic',
      'wand-magic-sparkles',
      'xmark',
      'xmark-large',
    ],
    label: 'Editing',
  },
  education: {
    icons: [
      'apple-whole',
      'atom',
      'atom-simple',
      'award',
      'backpack',
      'bell',
      'bell-school',
      'bell-school-slash',
      'bell-slash',
      'book-blank',
      'book-copy',
      'book-open',
      'book-open-cover',
      'book-open-reader',
      'books',
      'bus-school',
      'chalkboard',
      'chalkboard-user',
      'diploma',
      'file-certificate',
      'glasses-round',
      'globe-stand',
      'graduation-cap',
      'laptop-code',
      'laptop-file',
      'masks-theater',
      'microscope',
      'music',
      'pen-paintbrush',
      'person-chalkboard',
      'ruler-triangle',
      'school',
      'school-circle-check',
      'school-circle-exclamation',
      'school-circle-xmark',
      'school-flag',
      'school-lock',
      'screen-users',
      'shapes',
      'thought-bubble',
      'user-graduate',
    ],
    label: 'Education',
  },
  emoji: {
    icons: [
      'face-angry',
      'face-angry-horns',
      'face-anguished',
      'face-anxious-sweat',
      'face-astonished',
      'face-awesome',
      'face-beam-hand-over-mouth',
      'face-clouds',
      'face-confounded',
      'face-confused',
      'face-cowboy-hat',
      'face-diagonal-mouth',
      'face-disappointed',
      'face-disguise',
      'face-dizzy',
      'face-dotted',
      'face-downcast-sweat',
      'face-drooling',
      'face-exhaling',
      'face-explode',
      'face-expressionless',
      'face-eyes-xmarks',
      'face-fearful',
      'face-flushed',
      'face-frown',
      'face-frown-open',
      'face-frown-slight',
      'face-glasses',
      'face-grimace',
      'face-grin',
      'face-grin-beam',
      'face-grin-beam-sweat',
      'face-grin-hearts',
      'face-grin-squint',
      'face-grin-squint-tears',
      'face-grin-stars',
      'face-grin-tears',
      'face-grin-tongue',
      'face-grin-tongue-squint',
      'face-grin-tongue-wink',
      'face-grin-wide',
      'face-grin-wink',
      'face-hand-over-mouth',
      'face-hand-peeking',
      'face-hand-yawn',
      'face-head-bandage',
      'face-holding-back-tears',
      'face-hushed',
      'face-icicles',
      'face-kiss',
      'face-kiss-beam',
      'face-kiss-closed-eyes',
      'face-kiss-wink-heart',
      'face-laugh',
      'face-laugh-beam',
      'face-laugh-squint',
      'face-laugh-wink',
      'face-lying',
      'face-mask',
      'face-meh',
      'face-meh-blank',
      'face-melting',
      'face-monocle',
      'face-nauseated',
      'face-nose-steam',
      'face-party',
      'face-pensive',
      'face-persevering',
      'face-pleading',
      'face-pouting',
      'face-raised-eyebrow',
      'face-relieved',
      'face-rolling-eyes',
      'face-sad-cry',
      'face-sad-sweat',
      'face-sad-tear',
      'face-saluting',
      'face-scream',
      'face-shush',
      'face-sleeping',
      'face-sleepy',
      'face-smile',
      'face-smile-beam',
      'face-smile-halo',
      'face-smile-hearts',
      'face-smile-horns',
      'face-smile-relaxed',
      'face-smile-tear',
      'face-smile-tongue',
      'face-smile-upside-down',
      'face-smile-wink',
      'face-smiling-hands',
      'face-smirking',
      'face-spiral-eyes',
      'face-sunglasses',
      'face-surprise',
      'face-swear',
      'face-thermometer',
      'face-thinking',
      'face-tired',
      'face-tissue',
      'face-tongue-money',
      'face-tongue-sweat',
      'face-unamused',
      'face-vomit',
      'face-weary',
      'face-woozy',
      'face-worried',
      'face-zany',
      'face-zipper',
    ],
    label: 'Emoji',
  },
  energy: {
    icons: [
      'arrow-up-from-ground-water',
      'atom',
      'atom-simple',
      'battery-bolt',
      'battery-empty',
      'battery-exclamation',
      'battery-full',
      'battery-half',
      'battery-low',
      'battery-quarter',
      'battery-slash',
      'battery-three-quarters',
      'bolt',
      'burrito',
      'car-battery',
      'car-bolt',
      'car-circle-bolt',
      'car-side-bolt',
      'charging-station',
      'circle-radiation',
      'explosion',
      'fan',
      'fire',
      'fire-flame-curved',
      'fire-flame-simple',
      'gas-pump',
      'gas-pump-slash',
      'grate',
      'grate-droplet',
      'heat',
      'house-day',
      'house-night',
      'industry',
      'industry-windows',
      'lamp-street',
      'leaf',
      'lightbulb',
      'lightbulb-cfl',
      'manhole',
      'meter',
      'meter-bolt',
      'meter-droplet',
      'meter-fire',
      'oil-well',
      'outlet',
      'pedestal',
      'pipe-circle-check',
      'pipe-collar',
      'pipe-section',
      'pipe-valve',
      'plug',
      'plug-circle-bolt',
      'plug-circle-check',
      'plug-circle-exclamation',
      'plug-circle-minus',
      'plug-circle-plus',
      'plug-circle-xmark',
      'poop',
      'power-off',
      'radiation',
      'seedling',
      'solar-panel',
      'sun',
      'tower-broadcast',
      'transformer-bolt',
      'truck-bolt',
      'utility-pole',
      'utility-pole-double',
      'vent-damper',
      'water',
      'wind',
      'wind-turbine',
    ],
    label: 'Energy',
  },
  files: {
    icons: [
      'box-archive',
      'clone',
      'copy',
      'file',
      'file-arrow-down',
      'file-arrow-up',
      'file-audio',
      'file-binary',
      'file-check',
      'file-circle-check',
      'file-circle-exclamation',
      'file-circle-info',
      'file-circle-minus',
      'file-circle-plus',
      'file-circle-question',
      'file-circle-xmark',
      'file-code',
      'file-csv',
      'file-excel',
      'file-exclamation',
      'file-export',
      'file-heart',
      'file-image',
      'file-import',
      'file-lines',
      'file-lock',
      'file-magnifying-glass',
      'file-minus',
      'file-music',
      'file-pdf',
      'file-pen',
      'file-plus',
      'file-plus-minus',
      'file-powerpoint',
      'file-shield',
      'file-slash',
      'file-video',
      'file-word',
      'file-xmark',
      'file-zipper',
      'files',
      'floppy-disk',
      'folder',
      'folder-bookmark',
      'folder-closed',
      'folder-gear',
      'folder-grid',
      'folder-heart',
      'folder-image',
      'folder-magnifying-glass',
      'folder-medical',
      'folder-music',
      'folder-open',
      'folder-user',
      'memo',
      'memo-circle-check',
      'memo-circle-info',
      'memo-pad',
      'note-sticky',
      'page',
      'page-caret-down',
      'page-caret-up',
      'paste',
      'photo-film',
      'scissors',
    ],
    label: 'Files',
  },
  'film-video': {
    icons: [
      '360-degrees',
      'airplay',
      'album-collection',
      'amp-guitar',
      'audio-description',
      'audio-description-slash',
      'camcorder',
      'camera-cctv',
      'camera-movie',
      'camera-polaroid',
      'camera-security',
      'camera-web',
      'camera-web-slash',
      'cassette-betamax',
      'cassette-vhs',
      'circle',
      'circle-microphone',
      'circle-microphone-lines',
      'circle-video',
      'circle-waveform-lines',
      'clapperboard',
      'clapperboard-play',
      'closed-captioning',
      'cloud-music',
      'compact-disc',
      'computer-speaker',
      'dial',
      'dial-high',
      'dial-low',
      'dial-max',
      'dial-med',
      'dial-med-low',
      'dial-min',
      'dial-off',
      'disc-drive',
      'drone',
      'drone-front',
      'face-viewfinder',
      'file-audio',
      'file-video',
      'film',
      'film-canister',
      'film-simple',
      'film-slash',
      'frame',
      'gif',
      'head-side-headphones',
      'headphones',
      'high-definition',
      'microphone',
      'microphone-lines',
      'microphone-lines-slash',
      'microphone-slash',
      'microphone-stand',
      'photo-film',
      'photo-film-music',
      'podcast',
      'projector',
      'screencast',
      'signal-stream',
      'signal-stream-slash',
      'speaker',
      'speakers',
      'square-rss',
      'standard-definition',
      'star-sharp',
      'star-sharp-half',
      'star-sharp-half-stroke',
      'ticket',
      'tower-broadcast',
      'tower-cell',
      'tv',
      'tv-retro',
      'video',
      'video-arrow-down-left',
      'video-arrow-up-right',
      'video-plus',
      'video-slash',
      'waveform',
      'waveform-lines',
      'youtube',
    ],
    label: 'Film + Video',
  },
  'food-beverage': {
    icons: [
      'apple-whole',
      'bacon',
      'bagel',
      'baguette',
      'beer-mug',
      'beer-mug-empty',
      'blender',
      'bone',
      'bottle-droplet',
      'bottle-water',
      'bowl-chopsticks',
      'bowl-chopsticks-noodles',
      'bowl-food',
      'bowl-hot',
      'bowl-rice',
      'bowl-scoop',
      'bowl-scoops',
      'bowl-soft-serve',
      'bowl-spoon',
      'bread-loaf',
      'bread-slice',
      'bread-slice-butter',
      'burger',
      'burger-cheese',
      'burger-fries',
      'burger-glass',
      'burger-lettuce',
      'burger-soda',
      'burrito',
      'butter',
      'cake-candles',
      'cake-slice',
      'can-food',
      'candy',
      'candy-bar',
      'candy-cane',
      'candy-corn',
      'carrot',
      'champagne-glass',
      'champagne-glasses',
      'cheese',
      'cheese-swiss',
      'chopsticks',
      'cloud-meatball',
      'coffee-bean',
      'coffee-beans',
      'coffee-pot',
      'cookie',
      'corn',
      'crab',
      'crate-apple',
      'croissant',
      'cubes-stacked',
      'cup-straw',
      'cup-straw-swoosh',
      'cup-togo',
      'cupcake',
      'custard',
      'donut',
      'drumstick',
      'drumstick-bite',
      'egg',
      'egg-fried',
      'falafel',
      'fish',
      'fish-bones',
      'fish-cooked',
      'fish-fins',
      'flask',
      'flask-round-poison',
      'flask-round-potion',
      'flatbread',
      'flatbread-stuffed',
      'fondue-pot',
      'french-fries',
      'gingerbread-man',
      'glass',
      'glass-citrus',
      'glass-empty',
      'glass-half',
      'glass-water',
      'glass-water-droplet',
      'hat-chef',
      'honey-pot',
      'hotdog',
      'ice-cream',
      'jar',
      'jar-wheat',
      'jug',
      'lemon',
      'lobster',
      'lollipop',
      'martini-glass',
      'martini-glass-citrus',
      'martini-glass-empty',
      'meat',
      'mug',
      'mug-hot',
      'mug-marshmallows',
      'mug-saucer',
      'mug-tea',
      'mug-tea-saucer',
      'pan-food',
      'pan-frying',
      'pancakes',
      'pepper-hot',
      'pie',
      'pizza',
      'pizza-slice',
      'plate-wheat',
      'popcorn',
      'popsicle',
      'pot-food',
      'pretzel',
      'pumpkin',
      'salad',
      'salt-shaker',
      'sandwich',
      'sausage',
      'seedling',
      'shish-kebab',
      'shrimp',
      'soft-serve',
      'squid',
      'steak',
      'stroopwafel',
      'sushi',
      'sushi-roll',
      'taco',
      'tamale',
      'turkey',
      'user-chef',
      'waffle',
      'wheat',
      'wheat-awn',
      'wheat-awn-circle-exclamation',
      'wheat-awn-slash',
      'wheat-slash',
      'whiskey-glass',
      'whiskey-glass-ice',
      'wine-bottle',
      'wine-glass',
      'wine-glass-empty',
    ],
    label: 'Food + Beverage',
  },
  'fruits-vegetables': {
    icons: [
      'apple-core',
      'apple-whole',
      'avocado',
      'banana',
      'blueberries',
      'broccoli',
      'carrot',
      'cherries',
      'chestnut',
      'citrus',
      'citrus-slice',
      'coconut',
      'crate-apple',
      'crate-empty',
      'cucumber',
      'eggplant',
      'garlic',
      'grapes',
      'kiwi-fruit',
      'leaf',
      'leafy-green',
      'lemon',
      'mango',
      'melon',
      'melon-slice',
      'mushroom',
      'olive',
      'olive-branch',
      'onion',
      'peach',
      'peanut',
      'peanuts',
      'peapod',
      'pear',
      'pepper',
      'pepper-hot',
      'pineapple',
      'potato',
      'pumpkin',
      'salad',
      'seedling',
      'strawberry',
      'tomato',
      'watermelon-slice',
      'wheat',
    ],
    label: 'Fruits + Vegetables',
  },
  gaming: {
    icons: [
      'alien-8bit',
      'axe-battle',
      'block',
      'block-brick',
      'block-question',
      'book-skull',
      'book-sparkles',
      'bow-arrow',
      'campfire',
      'card-club',
      'card-diamond',
      'card-heart',
      'card-spade',
      'cards',
      'cards-blank',
      'chess',
      'chess-bishop',
      'chess-bishop-piece',
      'chess-board',
      'chess-clock',
      'chess-clock-flip',
      'chess-king',
      'chess-king-piece',
      'chess-knight',
      'chess-knight-piece',
      'chess-pawn',
      'chess-pawn-piece',
      'chess-queen',
      'chess-queen-piece',
      'chess-rook',
      'chess-rook-piece',
      'club',
      'critical-role',
      'crystal-ball',
      'd-and-d',
      'd-and-d-beyond',
      'dagger',
      'diamond',
      'dice',
      'dice-d10',
      'dice-d12',
      'dice-d20',
      'dice-d4',
      'dice-d6',
      'dice-d8',
      'dice-five',
      'dice-four',
      'dice-one',
      'dice-six',
      'dice-three',
      'dice-two',
      'dragon',
      'dreidel',
      'dungeon',
      'eye-evil',
      'fantasy-flight-games',
      'fire-flame',
      'flask-round-potion',
      'game-board',
      'game-board-simple',
      'game-console-handheld',
      'game-console-handheld-crank',
      'gamepad',
      'gamepad-modern',
      'ghost',
      'hammer-war',
      'hand-fist',
      'hand-holding-magic',
      'hat-wizard',
      'headset',
      'heart',
      'helmet-battle',
      'hood-cloak',
      'joystick',
      'mace',
      'mandolin',
      'mushroom',
      'nesting-dolls',
      'paw-claws',
      'person-pinball',
      'pickaxe',
      'pinata',
      'pinball',
      'playstation',
      'pool-8-ball',
      'puzzle',
      'puzzle-piece',
      'puzzle-piece-simple',
      'ring',
      'scroll',
      'scroll-old',
      'scythe',
      'shield-cross',
      'shield-halved',
      'shield-quartered',
      'sickle',
      'skull-crossbones',
      'slot-machine',
      'spade',
      'sparkles',
      'square-full',
      'square-steam',
      'staff',
      'steam',
      'steam-symbol',
      'sword',
      'swords',
      'teddy-bear',
      'treasure-chest',
      'twitch',
      'vr-cardboard',
      'wand',
      'wand-sparkles',
      'wizards-of-the-coast',
      'wreath-laurel',
      'xbox',
    ],
    label: 'Gaming',
  },
  gender: {
    icons: [
      'genderless',
      'mars',
      'mars-and-venus',
      'mars-double',
      'mars-stroke',
      'mars-stroke-right',
      'mars-stroke-up',
      'mercury',
      'neuter',
      'person-half-dress',
      'transgender',
      'venus',
      'venus-double',
      'venus-mars',
    ],
    label: 'Genders',
  },
  halloween: {
    icons: [
      'bat',
      'book-skull',
      'book-sparkles',
      'broom',
      'candle-holder',
      'candy',
      'candy-corn',
      'cat',
      'cauldron',
      'claw-marks',
      'cloud-moon',
      'coffin',
      'coffin-cross',
      'crow',
      'flask-round-poison',
      'flask-round-potion',
      'ghost',
      'hat-witch',
      'hat-wizard',
      'hockey-mask',
      'jack-o-lantern',
      'key-skeleton',
      'knife-kitchen',
      'lollipop',
      'mask',
      'mustache',
      'scarecrow',
      'scythe',
      'skull',
      'skull-crossbones',
      'sparkles',
      'spider',
      'spider-black-widow',
      'spider-web',
      'toilet-paper',
      'toilet-paper-blank',
      'tombstone',
      'tombstone-blank',
      'wand',
      'wand-sparkles',
    ],
    label: 'Halloween',
  },
  hands: {
    icons: [
      'hand',
      'hand-back-fist',
      'hand-back-point-down',
      'hand-back-point-left',
      'hand-back-point-ribbon',
      'hand-back-point-right',
      'hand-back-point-up',
      'hand-dots',
      'hand-fingers-crossed',
      'hand-fist',
      'hand-heart',
      'hand-holding',
      'hand-holding-box',
      'hand-holding-dollar',
      'hand-holding-droplet',
      'hand-holding-hand',
      'hand-holding-heart',
      'hand-holding-magic',
      'hand-holding-medical',
      'hand-holding-seedling',
      'hand-holding-skull',
      'hand-horns',
      'hand-lizard',
      'hand-love',
      'hand-middle-finger',
      'hand-peace',
      'hand-point-down',
      'hand-point-left',
      'hand-point-ribbon',
      'hand-point-right',
      'hand-point-up',
      'hand-pointer',
      'hand-scissors',
      'hand-sparkles',
      'hand-spock',
      'hand-wave',
      'hands-bound',
      'hands-bubbles',
      'hands-clapping',
      'hands-holding',
      'hands-holding-child',
      'hands-holding-circle',
      'hands-holding-diamond',
      'hands-holding-dollar',
      'hands-holding-heart',
      'hands-praying',
      'handshake',
      'handshake-angle',
      'handshake-simple',
      'handshake-simple-slash',
      'handshake-slash',
      'thumbs-down',
      'thumbs-up',
    ],
    label: 'Hands',
  },
  holidays: {
    icons: [
      'angel',
      'bells',
      'calendar-heart',
      'candy-cane',
      'carrot',
      'champagne-glass',
      'champagne-glasses',
      'chestnut',
      'cookie-bite',
      'cupcake',
      'deer',
      'deer-rudolph',
      'dreidel',
      'face-grin-hearts',
      'face-kiss-wink-heart',
      'fireplace',
      'gift',
      'gifts',
      'gingerbread-man',
      'hat-santa',
      'head-side-heart',
      'heart',
      'holly-berry',
      'jack-o-lantern',
      'lights-holiday',
      'menorah',
      'mistletoe',
      'mug-hot',
      'narwhal',
      'ornament',
      'party-bell',
      'party-horn',
      'pinata',
      'ring-diamond',
      'rings-wedding',
      'rv',
      'sleigh',
      'snowman',
      'snowman-head',
      'star-christmas',
      'stocking',
      'tree-christmas',
      'tree-decorated',
      'turkey',
      'wreath',
    ],
    label: 'Holidays',
  },
  household: {
    icons: [
      'air-conditioner',
      'arrow-up-from-water-pump',
      'bath',
      'bed',
      'bed-bunk',
      'bed-empty',
      'bed-front',
      'bell',
      'bell-on',
      'blanket',
      'blanket-fire',
      'blender',
      'blinds',
      'blinds-open',
      'blinds-raised',
      'block-brick',
      'block-brick-fire',
      'books',
      'bowl-spoon',
      'box-tissue',
      'broom-wide',
      'camera-cctv',
      'camera-security',
      'camera-web',
      'chair',
      'chair-office',
      'chopsticks',
      'circle-sort',
      'circle-sort-down',
      'circle-sort-up',
      'clock-desk',
      'clothes-hanger',
      'coffee-pot',
      'computer',
      'couch',
      'door-closed',
      'door-open',
      'dryer',
      'dryer-heat',
      'dungeon',
      'fan',
      'fan-table',
      'faucet',
      'faucet-drip',
      'fire-burner',
      'fire-hydrant',
      'fireplace',
      'flashlight',
      'fork',
      'fork-knife',
      'garage',
      'garage-car',
      'garage-open',
      'grill',
      'grill-fire',
      'grill-hot',
      'heat',
      'hose',
      'hose-reel',
      'house-chimney-heart',
      'house-chimney-user',
      'house-chimney-window',
      'house-day',
      'house-fire',
      'house-heart',
      'house-laptop',
      'house-lock',
      'house-night',
      'house-person-leave',
      'house-person-return',
      'house-signal',
      'house-user',
      'jar',
      'jar-wheat',
      'jug-detergent',
      'kitchen-set',
      'knife',
      'knife-kitchen',
      'lamp',
      'lamp-desk',
      'lamp-floor',
      'light-ceiling',
      'light-switch',
      'light-switch-off',
      'light-switch-on',
      'lightbulb',
      'lightbulb-cfl',
      'lightbulb-cfl-on',
      'lightbulb-on',
      'loveseat',
      'mailbox',
      'mailbox-flag-up',
      'mattress-pillow',
      'microwave',
      'mouse-field',
      'mug-saucer',
      'outlet',
      'oven',
      'pan-frying',
      'people-roof',
      'person-to-door',
      'phone-intercom',
      'plate-utensils',
      'plug',
      'pump',
      'pump-soap',
      'refrigerator',
      'rug',
      'sensor',
      'sensor-cloud',
      'sensor-fire',
      'sensor-on',
      'sensor-triangle-exclamation',
      'sheet-plastic',
      'shower',
      'shower-down',
      'shutters',
      'signal-stream',
      'sink',
      'siren',
      'siren-on',
      'snowflake',
      'soap',
      'speaker',
      'speakers',
      'spoon',
      'sprinkler',
      'sprinkler-ceiling',
      'square-ring',
      'stairs',
      'tank-water',
      'temperature-arrow-down',
      'temperature-arrow-up',
      'toilet',
      'toilet-paper',
      'toilet-paper-blank',
      'toilet-paper-blank-under',
      'toilet-paper-slash',
      'toilet-paper-under',
      'toilet-paper-under-slash',
      'toilet-paper-xmark',
      'tv',
      'tv-retro',
      'utensils',
      'utensils-slash',
      'vacuum',
      'vacuum-robot',
      'vent-damper',
      'washing-machine',
      'window-frame',
      'window-frame-open',
    ],
    label: 'Household',
  },
  humanitarian: {
    icons: [
      'anchor',
      'anchor-circle-check',
      'anchor-circle-exclamation',
      'anchor-circle-xmark',
      'anchor-lock',
      'arrow-down-up-across-line',
      'arrow-down-up-lock',
      'arrow-right-to-city',
      'arrow-up-from-ground-water',
      'arrow-up-from-water-pump',
      'arrow-up-right-dots',
      'arrow-up-right-from-square',
      'arrows-down-to-line',
      'arrows-down-to-people',
      'arrows-left-right-to-line',
      'arrows-spin',
      'arrows-split-up-and-left',
      'arrows-to-circle',
      'arrows-to-dot',
      'arrows-to-eye',
      'arrows-turn-right',
      'arrows-turn-to-dots',
      'arrows-up-to-line',
      'baby',
      'bacterium',
      'ban',
      'bed',
      'biohazard',
      'book-bookmark',
      'bore-hole',
      'bottle-droplet',
      'bottle-water',
      'bowl-food',
      'bowl-rice',
      'boxes-packing',
      'bridge',
      'bridge-circle-check',
      'bridge-circle-exclamation',
      'bridge-circle-xmark',
      'bridge-lock',
      'bridge-water',
      'bucket',
      'bugs',
      'building',
      'building-circle-arrow-right',
      'building-circle-check',
      'building-circle-exclamation',
      'building-circle-xmark',
      'building-columns',
      'building-flag',
      'building-lock',
      'building-ngo',
      'building-shield',
      'building-un',
      'building-user',
      'building-wheat',
      'burst',
      'bus',
      'car',
      'car-on',
      'car-tunnel',
      'child-combatant',
      'children',
      'church',
      'circle-h',
      'circle-nodes',
      'clipboard-question',
      'clipboard-user',
      'cloud-bolt',
      'cloud-showers-heavy',
      'cloud-showers-water',
      'computer',
      'cow',
      'cubes-stacked',
      'display',
      'droplet',
      'envelope',
      'envelope-circle-check',
      'explosion',
      'faucet-drip',
      'fax',
      'ferry',
      'file',
      'file-circle-check',
      'file-circle-exclamation',
      'file-circle-minus',
      'file-circle-plus',
      'file-circle-question',
      'file-circle-xmark',
      'file-csv',
      'file-pdf',
      'file-pen',
      'file-shield',
      'fire-burner',
      'fire-flame-simple',
      'fish-fins',
      'flag',
      'flask-vial',
      'gas-pump',
      'glass-water',
      'glass-water-droplet',
      'gopuram',
      'group-arrows-rotate',
      'hammer',
      'hand-holding-hand',
      'handcuffs',
      'hands-bound',
      'hands-bubbles',
      'hands-holding-child',
      'hands-holding-circle',
      'handshake-simple',
      'headset',
      'heart-circle-bolt',
      'heart-circle-check',
      'heart-circle-exclamation',
      'heart-circle-minus',
      'heart-circle-plus',
      'heart-circle-xmark',
      'helicopter',
      'helicopter-symbol',
      'helmet-un',
      'hill-avalanche',
      'hill-rockslide',
      'hospital',
      'hotel',
      'house-chimney',
      'house-chimney-crack',
      'house-circle-check',
      'house-circle-exclamation',
      'house-circle-xmark',
      'house-fire',
      'house-flag',
      'house-flood-water',
      'house-flood-water-circle-arrow-right',
      'house-lock',
      'house-medical',
      'house-medical-circle-check',
      'house-medical-circle-exclamation',
      'house-medical-circle-xmark',
      'house-medical-flag',
      'house-signal',
      'house-tsunami',
      'hurricane',
      'id-card',
      'jar',
      'jar-wheat',
      'jet-fighter-up',
      'jug-detergent',
      'kitchen-set',
      'land-mine-on',
      'landmark',
      'landmark-dome',
      'landmark-flag',
      'laptop',
      'laptop-file',
      'life-ring',
      'lines-leaning',
      'location-pin-lock',
      'locust',
      'lungs',
      'magnifying-glass-arrow-right',
      'magnifying-glass-chart',
      'mars-and-venus',
      'mars-and-venus-burst',
      'mask-face',
      'mask-ventilator',
      'mattress-pillow',
      'microscope',
      'mobile-retro',
      'mobile-screen',
      'money-bill-transfer',
      'money-bill-trend-up',
      'money-bill-wheat',
      'money-bills',
      'mosque',
      'mosquito',
      'mosquito-net',
      'mound',
      'mountain-city',
      'mountain-sun',
      'oil-well',
      'parachute-box',
      'people-arrows',
      'people-group',
      'people-line',
      'people-pulling',
      'people-robbery',
      'people-roof',
      'person',
      'person-arrow-down-to-line',
      'person-arrow-up-from-line',
      'person-breastfeeding',
      'person-burst',
      'person-cane',
      'person-chalkboard',
      'person-circle-check',
      'person-circle-exclamation',
      'person-circle-minus',
      'person-circle-plus',
      'person-circle-question',
      'person-circle-xmark',
      'person-digging',
      'person-dress',
      'person-dress-burst',
      'person-drowning',
      'person-falling',
      'person-falling-burst',
      'person-half-dress',
      'person-harassing',
      'person-military-pointing',
      'person-military-rifle',
      'person-military-to-person',
      'person-pregnant',
      'person-rays',
      'person-rifle',
      'person-shelter',
      'person-through-window',
      'person-walking',
      'person-walking-arrow-loop-left',
      'person-walking-arrow-right',
      'person-walking-dashed-line-arrow-right',
      'person-walking-luggage',
      'pills',
      'plane-circle-check',
      'plane-circle-exclamation',
      'plane-circle-xmark',
      'plane-lock',
      'plane-up',
      'plant-wilt',
      'plate-wheat',
      'plug',
      'plug-circle-bolt',
      'plug-circle-check',
      'plug-circle-exclamation',
      'plug-circle-minus',
      'plug-circle-plus',
      'plug-circle-xmark',
      'pump-soap',
      'radiation',
      'radio',
      'ranking-star',
      'road',
      'road-barrier',
      'road-bridge',
      'road-circle-check',
      'road-circle-exclamation',
      'road-circle-xmark',
      'road-lock',
      'road-spikes',
      'rug',
      'sack-dollar',
      'sack-xmark',
      'sailboat',
      'satellite-dish',
      'scale-balanced',
      'school',
      'school-circle-check',
      'school-circle-exclamation',
      'school-circle-xmark',
      'school-flag',
      'school-lock',
      'seedling',
      'sheet-plastic',
      'shield-cat',
      'shield-dog',
      'shield-heart',
      'ship',
      'shirt',
      'shop',
      'shop-lock',
      'shower',
      'skull-crossbones',
      'snowflake',
      'soap',
      'square-nfi',
      'square-person-confined',
      'square-virus',
      'staff-snake',
      'stethoscope',
      'suitcase-medical',
      'sun-plant-wilt',
      'syringe',
      'tarp',
      'tarp-droplet',
      'temperature-arrow-down',
      'temperature-arrow-up',
      'tent',
      'tent-arrow-down-to-line',
      'tent-arrow-left-right',
      'tent-arrow-turn-left',
      'tent-arrows-down',
      'tents',
      'toilet',
      'toilet-portable',
      'toilets-portable',
      'tornado',
      'tower-broadcast',
      'tower-cell',
      'tower-observation',
      'train-subway',
      'trash-can',
      'tree-city',
      'trowel',
      'trowel-bricks',
      'truck',
      'truck-arrow-right',
      'truck-droplet',
      'truck-field',
      'truck-field-un',
      'truck-front',
      'truck-medical',
      'truck-plane',
      'user-doctor',
      'user-injured',
      'users-between-lines',
      'users-line',
      'users-rays',
      'users-rectangle',
      'users-viewfinder',
      'vial-circle-check',
      'vial-virus',
      'vihara',
      'virus',
      'virus-covid',
      'volcano',
      'walkie-talkie',
      'wheat-awn',
      'wheat-awn-circle-exclamation',
      'wheelchair-move',
      'wifi',
      'wind',
      'worm',
      'xmarks-lines',
    ],
    label: 'Humanitarian',
  },
  logistics: {
    icons: [
      'anchor',
      'anchor-circle-check',
      'anchor-circle-exclamation',
      'anchor-circle-xmark',
      'anchor-lock',
      'barcode-read',
      'barcode-scan',
      'box',
      'box-check',
      'box-circle-check',
      'boxes-packing',
      'boxes-stacked',
      'bridge',
      'bridge-circle-check',
      'bridge-circle-exclamation',
      'bridge-circle-xmark',
      'bridge-lock',
      'bridge-water',
      'bus',
      'bus-simple',
      'car',
      'car-tunnel',
      'cart-flatbed',
      'cart-flatbed-boxes',
      'cart-flatbed-empty',
      'chart-simple',
      'chart-simple-horizontal',
      'clipboard-check',
      'clipboard-list',
      'clipboard-question',
      'conveyor-belt',
      'conveyor-belt-boxes',
      'conveyor-belt-empty',
      'crate-empty',
      'dolly',
      'dolly-empty',
      'ferry',
      'forklift',
      'gas-pump',
      'gas-pump-slash',
      'gears',
      'hand-holding-box',
      'hands-holding-diamond',
      'helicopter',
      'helicopter-symbol',
      'helmet-safety',
      'jet-fighter-up',
      'pallet',
      'pallet-box',
      'pallet-boxes',
      'person-carry-box',
      'person-dolly',
      'person-dolly-empty',
      'plane-circle-check',
      'plane-circle-exclamation',
      'plane-circle-xmark',
      'plane-lock',
      'rectangle-barcode',
      'reel',
      'road',
      'road-barrier',
      'road-bridge',
      'road-circle-check',
      'road-circle-exclamation',
      'road-circle-xmark',
      'road-lock',
      'sailboat',
      'scanner-gun',
      'scanner-keyboard',
      'scanner-touchscreen',
      'shelves',
      'shelves-empty',
      'square-kanban',
      'square-nfi',
      'tablet-rugged',
      'train',
      'train-subway',
      'train-subway-tunnel',
      'truck',
      'truck-arrow-right',
      'truck-clock',
      'truck-container-empty',
      'truck-fast',
      'truck-field',
      'truck-field-un',
      'truck-flatbed',
      'truck-front',
      'truck-plane',
      'user-helmet-safety',
      'warehouse',
      'warehouse-full',
      'xmarks-lines',
    ],
    label: 'Logistics',
  },
  maps: {
    icons: [
      'anchor',
      'bag-shopping',
      'bags-shopping',
      'ban-parking',
      'basket-shopping',
      'bath',
      'bed',
      'beer-mug-empty',
      'bell',
      'bell-slash',
      'bicycle',
      'binoculars',
      'bomb',
      'book',
      'book-atlas',
      'bookmark',
      'bridge',
      'bridge-suspension',
      'bridge-water',
      'briefcase',
      'building',
      'building-columns',
      'cake-candles',
      'camera-cctv',
      'car',
      'cart-shopping',
      'circle-dollar',
      'circle-info',
      'circle-location-arrow',
      'circle-parking',
      'compass-slash',
      'crosshairs',
      'crosshairs-simple',
      'diamond-turn-right',
      'do-not-enter',
      'dollar-sign',
      'draw-circle',
      'draw-polygon',
      'draw-square',
      'droplet',
      'eye',
      'eye-low-vision',
      'eye-slash',
      'fire',
      'fire-extinguisher',
      'fire-flame-curved',
      'flag',
      'flag-checkered',
      'flask',
      'fork',
      'fork-knife',
      'gamepad',
      'gavel',
      'gift',
      'globe',
      'graduation-cap',
      'heart',
      'heart-pulse',
      'helicopter',
      'helicopter-symbol',
      'hospital',
      'house',
      'image',
      'images',
      'industry',
      'industry-windows',
      'info',
      'jet-fighter',
      'key',
      'knife',
      'landmark',
      'landmark-flag',
      'layer-group',
      'layer-minus',
      'layer-plus',
      'leaf',
      'lemon',
      'life-ring',
      'lightbulb',
      'location-arrow',
      'location-check',
      'location-crosshairs',
      'location-crosshairs-slash',
      'location-dot',
      'location-dot-slash',
      'location-exclamation',
      'location-minus',
      'location-pen',
      'location-pin',
      'location-pin-lock',
      'location-pin-slash',
      'location-plus',
      'location-question',
      'location-smile',
      'location-xmark',
      'magnet',
      'magnifying-glass',
      'magnifying-glass-minus',
      'magnifying-glass-plus',
      'map',
      'map-pin',
      'martini-glass-empty',
      'money-bill',
      'money-bill-1',
      'motorcycle',
      'mountain-sun',
      'mug-saucer',
      'music',
      'newspaper',
      'paw',
      'person',
      'person-walking-with-cane',
      'phone',
      'phone-flip',
      'phone-volume',
      'plane',
      'plane-engines',
      'plug',
      'plus',
      'print',
      'recycle',
      'restroom',
      'road',
      'rocket',
      'route',
      'route-highway',
      'route-interstate',
      'scale-balanced',
      'scale-unbalanced',
      'scale-unbalanced-flip',
      'ship',
      'shoe-prints',
      'shower',
      'signs-post',
      'skull-cow',
      'snowplow',
      'spoon',
      'square-dollar',
      'square-h',
      'square-info',
      'square-parking',
      'square-parking-slash',
      'square-phone',
      'square-phone-flip',
      'square-plus',
      'street-view',
      'suitcase',
      'suitcase-medical',
      'tag',
      'tags',
      'taxi',
      'thumbtack',
      'ticket',
      'ticket-simple',
      'traffic-cone',
      'traffic-light',
      'traffic-light-go',
      'traffic-light-slow',
      'traffic-light-stop',
      'train',
      'train-subway',
      'train-track',
      'train-tram',
      'tree',
      'tree-deciduous',
      'trophy',
      'trophy-star',
      'truck',
      'truck-medical',
      'truck-plow',
      'tty',
      'umbrella',
      'utensils',
      'vest',
      'vest-patches',
      'wheelchair',
      'wheelchair-move',
      'wifi',
      'wine-glass',
      'wrench',
    ],
    label: 'Maps',
  },
  maritime: {
    icons: [
      'anchor',
      'anchor-circle-check',
      'anchor-circle-exclamation',
      'anchor-circle-xmark',
      'anchor-lock',
      'bridge-suspension',
      'buoy',
      'buoy-mooring',
      'crab',
      'dolphin',
      'duck',
      'ferry',
      'fish',
      'fish-bones',
      'fish-cooked',
      'fish-fins',
      'fishing-rod',
      'lobster',
      'narwhal',
      'otter',
      'person-swimming',
      'sailboat',
      'ship',
      'shrimp',
      'squid',
      'water',
      'water-arrow-down',
      'water-arrow-up',
      'whale',
    ],
    label: 'Maritime',
  },
  marketing: {
    icons: [
      'arrows-spin',
      'arrows-to-dot',
      'arrows-to-eye',
      'badge',
      'badge-check',
      'badge-dollar',
      'badge-percent',
      'billboard',
      'block-question',
      'bullhorn',
      'bullseye',
      'bullseye-arrow',
      'bullseye-pointer',
      'chart-mixed',
      'chart-simple',
      'chart-simple-horizontal',
      'comment-dollar',
      'comments-dollar',
      'envelope-open-dollar',
      'envelope-open-text',
      'envelopes-bulk',
      'filter-circle-dollar',
      'gift-card',
      'group-arrows-rotate',
      'hundred-points',
      'lightbulb',
      'lightbulb-cfl',
      'lightbulb-cfl-on',
      'lightbulb-dollar',
      'lightbulb-exclamation',
      'lightbulb-on',
      'lightbulb-slash',
      'magnifying-glass-arrow-right',
      'magnifying-glass-chart',
      'magnifying-glass-dollar',
      'magnifying-glass-location',
      'megaphone',
      'message-dollar',
      'messages-dollar',
      'people-group',
      'person-rays',
      'ranking-star',
      'rectangle-ad',
      'rectangle-pro',
      'signal-stream',
      'signal-stream-slash',
      'sparkle',
      'sparkles',
      'square-poll-horizontal',
      'square-poll-vertical',
      'timeline',
      'timeline-arrow',
      'user-crown',
      'user-group-crown',
    ],
    label: 'Marketing',
  },
  mathematics: {
    icons: [
      'abacus',
      'calculator',
      'calculator-simple',
      'circle-divide',
      'circle-minus',
      'circle-plus',
      'circle-xmark',
      'divide',
      'empty-set',
      'equals',
      'function',
      'greater-than',
      'greater-than-equal',
      'hexagon-divide',
      'hexagon-minus',
      'hexagon-plus',
      'hexagon-xmark',
      'infinity',
      'integral',
      'intersection',
      'lambda',
      'less-than',
      'less-than-equal',
      'minus',
      'not-equal',
      'octagon-divide',
      'octagon-minus',
      'octagon-plus',
      'octagon-xmark',
      'omega',
      'percent',
      'pi',
      'plus',
      'plus-minus',
      'sigma',
      'square-divide',
      'square-minus',
      'square-root',
      'square-root-variable',
      'square-xmark',
      'subscript',
      'superscript',
      'tally',
      'tally-1',
      'tally-2',
      'tally-3',
      'tally-4',
      'theta',
      'tilde',
      'union',
      'value-absolute',
      'watch-calculator',
      'wave-sine',
      'wave-square',
      'wave-triangle',
      'xmark',
    ],
    label: 'Mathematics',
  },
  'media-playback': {
    icons: [
      'arrow-rotate-left',
      'arrow-rotate-right',
      'arrows-maximize',
      'arrows-repeat',
      'arrows-repeat-1',
      'arrows-rotate',
      'backward',
      'backward-fast',
      'backward-step',
      'circle-pause',
      'circle-play',
      'circle-stop',
      'compress',
      'compress-wide',
      'down-left-and-up-right-to-center',
      'eject',
      'expand',
      'expand-wide',
      'forward',
      'forward-fast',
      'forward-step',
      'hand',
      'maximize',
      'minimize',
      'music',
      'pause',
      'phone-volume',
      'play',
      'play-pause',
      'plus-minus',
      'repeat',
      'repeat-1',
      'rotate',
      'rotate-left',
      'rotate-right',
      'rss',
      'scrubber',
      'shuffle',
      'sliders',
      'sliders-up',
      'stop',
      'up-right-and-down-left-from-center',
      'volume',
      'volume-high',
      'volume-low',
      'volume-off',
      'volume-slash',
      'volume-xmark',
    ],
    label: 'Media Playback',
  },
  'medical-health': {
    icons: [
      'accessible-icon',
      'bacteria',
      'bacterium',
      'ban-smoking',
      'bandage',
      'bed-pulse',
      'biohazard',
      'bone',
      'bone-break',
      'bong',
      'book-medical',
      'book-user',
      'books-medical',
      'brain',
      'briefcase-medical',
      'cannabis',
      'capsules',
      'cauldron',
      'circle-h',
      'circle-radiation',
      'clipboard-medical',
      'clipboard-prescription',
      'clipboard-user',
      'clock-rotate-left',
      'comment-medical',
      'crutch',
      'crutches',
      'disease',
      'display-medical',
      'dna',
      'ear',
      'eye',
      'eye-dropper',
      'eyes',
      'face-head-bandage',
      'face-mask',
      'face-thermometer',
      'face-vomit',
      'file-medical',
      'file-prescription',
      'file-waveform',
      'files-medical',
      'fire-flame-simple',
      'flask',
      'flask-round-potion',
      'flask-vial',
      'folder-medical',
      'hand-dots',
      'hand-holding-medical',
      'head-side-brain',
      'head-side-cough',
      'head-side-cough-slash',
      'head-side-mask',
      'head-side-medical',
      'head-side-virus',
      'heart',
      'heart-circle-bolt',
      'heart-circle-check',
      'heart-circle-exclamation',
      'heart-circle-minus',
      'heart-circle-plus',
      'heart-circle-xmark',
      'heart-pulse',
      'hospital',
      'hospital-user',
      'hospitals',
      'house-chimney-medical',
      'house-medical',
      'house-medical-circle-check',
      'house-medical-circle-exclamation',
      'house-medical-circle-xmark',
      'house-medical-flag',
      'id-card-clip',
      'inhaler',
      'joint',
      'kidneys',
      'kit-medical',
      'laptop-medical',
      'lips',
      'lungs',
      'lungs-virus',
      'mask-face',
      'mask-ventilator',
      'message-medical',
      'microscope',
      'monitor-waveform',
      'mortar-pestle',
      'nose',
      'note-medical',
      'notes-medical',
      'pager',
      'person-breastfeeding',
      'person-cane',
      'person-dots-from-line',
      'person-half-dress',
      'pills',
      'plus',
      'poop',
      'prescription',
      'prescription-bottle',
      'prescription-bottle-medical',
      'prescription-bottle-pill',
      'pump-medical',
      'radiation',
      'receipt',
      'scalpel',
      'scalpel-line-dashed',
      'shield-virus',
      'skeleton',
      'skeleton-ribs',
      'skull',
      'skull-crossbones',
      'smoking',
      'square-h',
      'square-plus',
      'square-virus',
      'staff-snake',
      'star-of-life',
      'stethoscope',
      'stomach',
      'stretcher',
      'suitcase-medical',
      'syringe',
      'tablets',
      'teeth',
      'teeth-open',
      'thermometer',
      'tooth',
      'toothbrush',
      'truck-medical',
      'user-doctor',
      'user-doctor-hair',
      'user-doctor-hair-long',
      'user-doctor-message',
      'user-nurse',
      'user-nurse-hair',
      'user-nurse-hair-long',
      'users-medical',
      'vial',
      'vial-circle-check',
      'vial-virus',
      'vials',
      'virus',
      'virus-covid',
      'virus-covid-slash',
      'virus-slash',
      'viruses',
      'walker',
      'watch-fitness',
      'wave-pulse',
      'weight-scale',
      'wheelchair',
      'wheelchair-move',
      'x-ray',
    ],
    label: 'Medical + Health',
  },
  money: {
    icons: [
      'austral-sign',
      'badge-dollar',
      'badge-percent',
      'baht-sign',
      'bangladeshi-taka-sign',
      'bitcoin',
      'bitcoin-sign',
      'brazilian-real-sign',
      'btc',
      'cash-register',
      'cedi-sign',
      'cent-sign',
      'chart-line',
      'chart-line-down',
      'chart-mixed',
      'chart-pie',
      'chart-pie-simple',
      'circle-dollar',
      'circle-dollar-to-slot',
      'circle-euro',
      'circle-sterling',
      'circle-yen',
      'coin',
      'coin-blank',
      'coin-front',
      'coin-vertical',
      'coins',
      'colon-sign',
      'comment-dollar',
      'comments-dollar',
      'credit-card',
      'credit-card-blank',
      'credit-card-front',
      'cruzeiro-sign',
      'dollar-sign',
      'dong-sign',
      'ethereum',
      'euro-sign',
      'file-chart-column',
      'file-chart-pie',
      'file-invoice',
      'file-invoice-dollar',
      'florin-sign',
      'franc-sign',
      'gg',
      'gg-circle',
      'guarani-sign',
      'hand-holding-dollar',
      'hands-holding-dollar',
      'hryvnia-sign',
      'indian-rupee-sign',
      'kip-sign',
      'landmark',
      'lari-sign',
      'lira-sign',
      'litecoin-sign',
      'manat-sign',
      'message-dollar',
      'messages-dollar',
      'mill-sign',
      'money-bill',
      'money-bill-1',
      'money-bill-1-wave',
      'money-bill-simple',
      'money-bill-simple-wave',
      'money-bill-transfer',
      'money-bill-trend-up',
      'money-bill-wave',
      'money-bill-wheat',
      'money-bills',
      'money-bills-simple',
      'money-check',
      'money-check-dollar',
      'money-from-bracket',
      'money-simple-from-bracket',
      'naira-sign',
      'percent',
      'peseta-sign',
      'peso-sign',
      'piggy-bank',
      'receipt',
      'ruble-sign',
      'rupee-sign',
      'rupiah-sign',
      'sack',
      'sack-dollar',
      'sack-xmark',
      'scale-balanced',
      'scale-unbalanced',
      'scale-unbalanced-flip',
      'shekel-sign',
      'square-dollar',
      'stamp',
      'sterling-sign',
      'tally',
      'tenge-sign',
      'treasure-chest',
      'tugrik-sign',
      'turkish-lira-sign',
      'vault',
      'wallet',
      'won-sign',
      'yen-sign',
    ],
    label: 'Money',
  },
  moving: {
    icons: [
      'blanket',
      'box-archive',
      'box-open',
      'box-open-full',
      'box-taped',
      'boxes-packing',
      'caravan',
      'caravan-simple',
      'container-storage',
      'couch',
      'dolly',
      'dolly-empty',
      'house-chimney',
      'house-person-leave',
      'house-person-return',
      'lamp',
      'loveseat',
      'people-carry-box',
      'person-carry-box',
      'person-dolly',
      'person-dolly-empty',
      'ramp-loading',
      'route',
      'sign-hanging',
      'square-fragile',
      'square-this-way-up',
      'suitcase',
      'tape',
      'trailer',
      'truck-container',
      'truck-moving',
      'truck-ramp',
      'truck-ramp-box',
      'truck-ramp-couch',
      'vacuum',
      'wine-glass',
      'wine-glass-crack',
    ],
    label: 'Moving',
  },
  'music-audio': {
    icons: [
      'airplay',
      'album',
      'album-circle-plus',
      'album-circle-user',
      'album-collection',
      'album-collection-circle-plus',
      'album-collection-circle-user',
      'amp-guitar',
      'banjo',
      'bells',
      'boombox',
      'cassette-tape',
      'circle-microphone',
      'circle-microphone-lines',
      'clarinet',
      'cloud-music',
      'comment-music',
      'compact-disc',
      'computer-speaker',
      'cowbell',
      'cowbell-circle-plus',
      'dial',
      'dial-high',
      'dial-low',
      'dial-max',
      'dial-med',
      'dial-med-low',
      'dial-min',
      'dial-off',
      'disc-drive',
      'drum',
      'drum-steelpan',
      'ear',
      'file-audio',
      'file-music',
      'flute',
      'folder-music',
      'gramophone',
      'guitar',
      'guitar-electric',
      'guitars',
      'head-side-headphones',
      'headphones',
      'headphones-simple',
      'kazoo',
      'list-music',
      'mandolin',
      'message-music',
      'microphone',
      'microphone-lines',
      'microphone-lines-slash',
      'microphone-slash',
      'microphone-stand',
      'mp3-player',
      'music',
      'music-note',
      'music-note-slash',
      'music-slash',
      'napster',
      'photo-film-music',
      'piano',
      'piano-keyboard',
      'radio',
      'radio-tuner',
      'record-vinyl',
      'saxophone',
      'saxophone-fire',
      'screencast',
      'sliders',
      'sliders-up',
      'soundcloud',
      'speaker',
      'speakers',
      'spotify',
      'square-sliders',
      'square-sliders-vertical',
      'triangle-instrument',
      'trumpet',
      'turntable',
      'tv-music',
      'user-music',
      'violin',
      'volume',
      'volume-high',
      'volume-low',
      'volume-off',
      'volume-slash',
      'volume-xmark',
      'waveform',
      'waveform-lines',
      'whistle',
    ],
    label: 'Music + Audio',
  },
  nature: {
    icons: [
      'acorn',
      'bench-tree',
      'binoculars',
      'bug',
      'bugs',
      'cactus',
      'cannabis',
      'chestnut',
      'cloud-sun',
      'clover',
      'feather',
      'feather-pointed',
      'fire',
      'fire-smoke',
      'flower',
      'flower-daffodil',
      'flower-tulip',
      'frog',
      'house-tree',
      'icicles',
      'leaf',
      'leaf-maple',
      'leaf-oak',
      'locust',
      'mosquito',
      'mound',
      'mountain',
      'mountain-city',
      'mountain-sun',
      'mountains',
      'mushroom',
      'person-hiking',
      'plant-wilt',
      'pompebled',
      'raindrops',
      'seedling',
      'signs-post',
      'spider',
      'spider-black-widow',
      'spider-web',
      'tree',
      'tree-deciduous',
      'tree-large',
      'tree-palm',
      'trees',
      'trillium',
      'volcano',
      'water',
      'wind',
      'worm',
    ],
    label: 'Nature',
  },
  numbers: {
    icons: [
      '0',
      '00',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'circle-0',
      'circle-1',
      'circle-2',
      'circle-3',
      'circle-4',
      'circle-5',
      'circle-6',
      'circle-7',
      'circle-8',
      'circle-9',
      'hundred-points',
      'square-0',
      'square-1',
      'square-2',
      'square-3',
      'square-4',
      'square-5',
      'square-6',
      'square-7',
      'square-8',
      'square-9',
    ],
    label: 'Numbers',
  },
  'photos-images': {
    icons: [
      '360-degrees',
      'aperture',
      'bolt',
      'bolt-auto',
      'bolt-lightning',
      'bolt-slash',
      'camera',
      'camera-polaroid',
      'camera-retro',
      'camera-rotate',
      'camera-slash',
      'camera-viewfinder',
      'chalkboard',
      'circle-camera',
      'circle-half-stroke',
      'clone',
      'comment-image',
      'droplet',
      'eye',
      'eye-dropper',
      'eye-slash',
      'face-viewfinder',
      'file-image',
      'film',
      'film-canister',
      'film-simple',
      'film-slash',
      'films',
      'folder-image',
      'gif',
      'hexagon-image',
      'high-definition',
      'id-badge',
      'id-card',
      'image',
      'image-landscape',
      'image-polaroid',
      'image-polaroid-user',
      'image-portrait',
      'image-slash',
      'image-user',
      'images',
      'images-user',
      'message-image',
      'minimize',
      'panorama',
      'photo-film',
      'photo-film-music',
      'rectangle-history',
      'rectangle-history-circle-plus',
      'rectangle-history-circle-user',
      'rectangle-vertical-history',
      'sliders',
      'sliders-up',
      'square-sliders',
      'square-sliders-vertical',
      'standard-definition',
      'unsplash',
    ],
    label: 'Photos + Images',
  },
  political: {
    icons: [
      'award',
      'ballot',
      'ballot-check',
      'booth-curtain',
      'box-ballot',
      'building-flag',
      'bullhorn',
      'calendar-star',
      'check-double',
      'check-to-slot',
      'circle-dollar-to-slot',
      'clipboard-list-check',
      'democrat',
      'dove',
      'dumpster-fire',
      'flag-swallowtail',
      'flag-usa',
      'hand-fist',
      'handshake',
      'landmark-dome',
      'landmark-flag',
      'person-booth',
      'person-sign',
      'piggy-bank',
      'podium',
      'podium-star',
      'poll-people',
      'republican',
      'scale-balanced',
      'scale-unbalanced',
      'scale-unbalanced-flip',
      'tally',
      'xmark-to-slot',
    ],
    label: 'Political',
  },
  'punctuation-symbols': {
    icons: [
      'accent-grave',
      'alt',
      'ampersand',
      'apostrophe',
      'asterisk',
      'at',
      'bracket-curly',
      'bracket-curly-right',
      'bracket-round',
      'bracket-round-right',
      'bracket-square',
      'bracket-square-right',
      'brackets-round',
      'check',
      'check-double',
      'circle-ampersand',
      'circle-exclamation',
      'circle-question',
      'colon',
      'comma',
      'corner',
      'dash',
      'ditto',
      'equals',
      'exclamation',
      'greater-than',
      'hashtag',
      'horizontal-rule',
      'hyphen',
      'interrobang',
      'less-than',
      'minus',
      'option',
      'percent',
      'period',
      'pipe',
      'plus',
      'question',
      'quote-left',
      'quote-right',
      'quotes',
      'section',
      'semicolon',
      'slash-back',
      'slash-forward',
      'square-ampersand',
      'square-question',
      'square-quote',
      'tick',
      'tilde',
    ],
    label: 'Punctuation + Symbols',
  },
  religion: {
    icons: [
      'ankh',
      'atom',
      'bahai',
      'book-bible',
      'book-journal-whills',
      'book-quran',
      'book-tanakh',
      'church',
      'coffin-cross',
      'cross',
      'dharmachakra',
      'dove',
      'gopuram',
      'hamsa',
      'hands-praying',
      'hanukiah',
      'jedi',
      'kaaba',
      'khanda',
      'menorah',
      'mosque',
      'om',
      'peace',
      'person-praying',
      'place-of-worship',
      'scroll-torah',
      'spaghetti-monster-flying',
      'star-and-crescent',
      'star-of-david',
      'synagogue',
      'tombstone',
      'tombstone-blank',
      'torii-gate',
      'vihara',
      'yin-yang',
    ],
    label: 'Religion',
  },
  science: {
    icons: [
      'atom',
      'atom-simple',
      'biohazard',
      'book-sparkles',
      'brain',
      'buoy-mooring',
      'capsules',
      'cauldron',
      'chart-mixed',
      'chart-network',
      'chart-scatter',
      'circle-radiation',
      'clipboard-check',
      'disease',
      'dna',
      'eye-dropper',
      'filter',
      'fire',
      'fire-flame-curved',
      'fire-flame-simple',
      'flask',
      'flask-round-poison',
      'flask-round-potion',
      'flask-vial',
      'frog',
      'head-side-brain',
      'key-skeleton',
      'kite',
      'magnet',
      'microscope',
      'mortar-pestle',
      'pills',
      'prescription-bottle',
      'radiation',
      'seedling',
      'skull-crossbones',
      'square-virus',
      'syringe',
      'tablets',
      'tally',
      'temperature-high',
      'temperature-low',
      'vial',
      'vial-circle-check',
      'vial-virus',
      'vials',
    ],
    label: 'Science',
  },
  'science-fiction': {
    icons: [
      'alien',
      'alien-8bit',
      'atom',
      'atom-simple',
      'book-journal-whills',
      'cat-space',
      'drone',
      'drone-front',
      'explosion',
      'flux-capacitor',
      'galactic-republic',
      'galactic-senate',
      'hand-spock',
      'jedi',
      'jedi-order',
      'old-republic',
      'person-from-portal',
      'person-to-portal',
      'police-box',
      'raygun',
      'robot',
      'robot-astromech',
      'rocket',
      'rocket-launch',
      'space-awesome',
      'space-station-moon',
      'space-station-moon-construction',
      'starfighter',
      'starfighter-twin-ion-engine',
      'starfighter-twin-ion-engine-advanced',
      'starship',
      'starship-freighter',
      'sword-laser',
      'sword-laser-alt',
      'swords-laser',
      'transporter',
      'transporter-1',
      'transporter-2',
      'transporter-3',
      'transporter-4',
      'transporter-5',
      'transporter-6',
      'transporter-7',
      'transporter-empty',
      'ufo',
      'ufo-beam',
      'user-alien',
      'user-astronaut',
      'user-bounty-hunter',
      'user-hair-buns',
      'user-robot',
      'user-robot-xmarks',
      'user-visor',
      'watch-calculator',
    ],
    label: 'Science Fiction',
  },
  security: {
    icons: [
      'badge-sheriff',
      'ban',
      'ban-bug',
      'blanket-fire',
      'block-brick-fire',
      'book-section',
      'bug',
      'bug-slash',
      'building-lock',
      'building-shield',
      'buoy-mooring',
      'burst',
      'camera-cctv',
      'car-on',
      'diamond-exclamation',
      'do-not-enter',
      'door-closed',
      'door-open',
      'dungeon',
      'explosion',
      'eye',
      'eye-slash',
      'face-viewfinder',
      'file-certificate',
      'file-contract',
      'file-lock',
      'file-shield',
      'file-signature',
      'fingerprint',
      'gun',
      'gun-slash',
      'handcuffs',
      'hands-bound',
      'hands-holding-child',
      'hands-holding-circle',
      'house-fire',
      'house-lock',
      'id-badge',
      'id-card',
      'id-card-clip',
      'key',
      'key-skeleton',
      'land-mine-on',
      'light-emergency',
      'light-emergency-on',
      'lock',
      'lock-keyhole',
      'lock-keyhole-open',
      'lock-open',
      'mars-and-venus-burst',
      'mask',
      'octagon-exclamation',
      'panel-ews',
      'panel-fire',
      'passport',
      'people-pulling',
      'people-robbery',
      'person-burst',
      'person-dress-burst',
      'person-falling-burst',
      'person-harassing',
      'person-military-pointing',
      'person-military-rifle',
      'person-military-to-person',
      'person-rifle',
      'person-shelter',
      'person-through-window',
      'person-to-door',
      'phone-intercom',
      'road-spikes',
      'shield',
      'shield-cat',
      'shield-check',
      'shield-dog',
      'shield-exclamation',
      'shield-halved',
      'shield-heart',
      'shield-keyhole',
      'shield-minus',
      'shield-plus',
      'shield-slash',
      'shield-xmark',
      'siren',
      'siren-on',
      'skull-crossbones',
      'sprinkler-ceiling',
      'square-person-confined',
      'tower-observation',
      'unlock',
      'unlock-keyhole',
      'usb-drive',
      'user-lock',
      'user-police',
      'user-police-tie',
      'user-secret',
      'user-shield',
      'user-unlock',
      'vault',
      'whistle',
    ],
    label: 'Security',
  },
  shapes: {
    icons: [
      'badge',
      'ball-pile',
      'bookmark',
      'burst',
      'calendar',
      'certificate',
      'circle',
      'circle-bolt',
      'circle-dashed',
      'circle-half',
      'circle-half-stroke',
      'circle-heart',
      'circle-quarter',
      'circle-quarter-stroke',
      'circle-quarters',
      'circle-small',
      'circle-star',
      'circle-three-quarters',
      'circle-three-quarters-stroke',
      'cloud',
      'clover',
      'club',
      'comment',
      'crown',
      'cubes-stacked',
      'diamond',
      'diamond-half',
      'diamond-half-stroke',
      'file',
      'folder',
      'heart',
      'heart-crack',
      'heart-half',
      'heart-half-stroke',
      'hexagon',
      'lines-leaning',
      'location-pin',
      'octagon',
      'play',
      'rectangle',
      'rectangle-vertical',
      'rectangle-wide',
      'rhombus',
      'seal',
      'shapes',
      'shield',
      'spade',
      'sparkle',
      'square',
      'square-bolt',
      'square-dashed',
      'square-dashed-circle-plus',
      'square-quarters',
      'square-ring',
      'square-small',
      'square-star',
      'star',
      'star-sharp',
      'star-sharp-half',
      'star-sharp-half-stroke',
      'ticket-simple',
      'triangle',
    ],
    label: 'Shapes',
  },
  shopping: {
    icons: [
      'alipay',
      'amazon-pay',
      'apple-pay',
      'badge',
      'badge-check',
      'badge-dollar',
      'badge-percent',
      'bag-shopping',
      'bags-shopping',
      'balloon',
      'balloons',
      'barcode',
      'barcode-read',
      'barcode-scan',
      'basket-shopping',
      'basket-shopping-simple',
      'bell',
      'bitcoin',
      'bookmark',
      'booth-curtain',
      'box-open-full',
      'btc',
      'bullhorn',
      'camera',
      'camera-retro',
      'cart-arrow-down',
      'cart-arrow-up',
      'cart-circle-arrow-down',
      'cart-circle-arrow-up',
      'cart-circle-check',
      'cart-circle-exclamation',
      'cart-circle-plus',
      'cart-circle-xmark',
      'cart-minus',
      'cart-plus',
      'cart-shopping',
      'cart-shopping-fast',
      'cart-xmark',
      'cash-register',
      'cc-amazon-pay',
      'cc-amex',
      'cc-apple-pay',
      'cc-diners-club',
      'cc-discover',
      'cc-jcb',
      'cc-mastercard',
      'cc-paypal',
      'cc-stripe',
      'cc-visa',
      'certificate',
      'credit-card',
      'credit-card-blank',
      'credit-card-front',
      'ethereum',
      'gem',
      'gift',
      'gift-card',
      'gifts',
      'google-pay',
      'google-wallet',
      'hand-holding-box',
      'handshake',
      'heart',
      'hexagon-image',
      'hexagon-vertical-nft',
      'hexagon-vertical-nft-slanted',
      'key',
      'mobile-signal',
      'mobile-signal-out',
      'money-check',
      'money-check-dollar',
      'money-check-dollar-pen',
      'money-check-pen',
      'moped',
      'nfc',
      'nfc-directional',
      'nfc-lock',
      'nfc-magnifying-glass',
      'nfc-pen',
      'nfc-signal',
      'nfc-slash',
      'nfc-symbol',
      'nfc-trash',
      'paypal',
      'person-booth',
      'receipt',
      'rectangle-barcode',
      'shirt',
      'shop',
      'shop-lock',
      'shop-slash',
      'star',
      'star-exclamation',
      'store',
      'store-lock',
      'store-slash',
      'stripe',
      'stripe-s',
      'tag',
      'tags',
      'thumbs-down',
      'thumbs-up',
      'trophy',
      'trophy-star',
      'truck',
      'truck-bolt',
      'truck-clock',
      'truck-container',
      'truck-fast',
    ],
    label: 'Shopping',
  },
  social: {
    icons: [
      'arrows-retweet',
      'bags-shopping',
      'bell',
      'bird',
      'cake-candles',
      'camera',
      'circle-envelope',
      'circle-user',
      'comment',
      'envelope',
      'hashtag',
      'heart',
      'icons',
      'image',
      'images',
      'location-dot',
      'location-pin',
      'message',
      'paper-plane-top',
      'photo-film',
      'photo-film-music',
      'retweet',
      'share',
      'share-from-square',
      'share-nodes',
      'signal-stream',
      'sparkles',
      'square-poll-horizontal',
      'square-poll-vertical',
      'square-share-nodes',
      'star',
      'symbols',
      'thumbs-down',
      'thumbs-up',
      'thumbtack',
      'user',
      'user-crown',
      'user-group',
      'user-group-crown',
      'user-plus',
      'users',
      'video',
    ],
    label: 'Social',
  },
  spinners: {
    icons: [
      'arrows-spin',
      'asterisk',
      'atom',
      'atom-simple',
      'badge',
      'bahai',
      'bullseye-arrow',
      'certificate',
      'circle-notch',
      'compact-disc',
      'compass',
      'crosshairs',
      'dharmachakra',
      'fan',
      'gear',
      'hurricane',
      'life-ring',
      'loader',
      'moon-over-sun',
      'palette',
      'ring',
      'rotate',
      'slash',
      'snowflake',
      'spider-web',
      'spinner',
      'spinner-third',
      'star-christmas',
      'steering-wheel',
      'stroopwafel',
      'sun',
      'tire',
      'tire-rugged',
      'wreath',
      'yin-yang',
    ],
    label: 'Spinners',
  },
  'sports-fitness': {
    icons: [
      'award-simple',
      'badminton',
      'baseball',
      'baseball-bat-ball',
      'basketball',
      'basketball-hoop',
      'bicycle',
      'book-heart',
      'bowling-ball',
      'bowling-ball-pin',
      'bowling-pins',
      'boxing-glove',
      'broom-ball',
      'cricket-bat-ball',
      'curling-stone',
      'dumbbell',
      'field-hockey-stick-ball',
      'fire-flame-curved',
      'fire-flame-simple',
      'fishing-rod',
      'flag-pennant',
      'flying-disc',
      'football',
      'football-helmet',
      'futbol',
      'goal-net',
      'golf-ball-tee',
      'golf-club',
      'golf-flag-hole',
      'heart',
      'heart-pulse',
      'hockey-mask',
      'hockey-puck',
      'hockey-stick-puck',
      'hockey-sticks',
      'ice-skate',
      'lacrosse-stick',
      'lacrosse-stick-ball',
      'luchador-mask',
      'mask-snorkel',
      'medal',
      'monitor-waveform',
      'mound',
      'person-biking',
      'person-biking-mountain',
      'person-hiking',
      'person-running',
      'person-skating',
      'person-ski-jumping',
      'person-skiing',
      'person-skiing-nordic',
      'person-sledding',
      'person-snowboarding',
      'person-swimming',
      'person-walking',
      'pickaxe',
      'pickleball',
      'racquet',
      'ranking-star',
      'rugby-ball',
      'shirt-running',
      'shoe-prints',
      'shuttlecock',
      'ski-boot',
      'ski-boot-ski',
      'spa',
      'sportsball',
      'stopwatch-20',
      'table-tennis-paddle-ball',
      'tennis-ball',
      'uniform-martial-arts',
      'volleyball',
      'watch-apple',
      'watch-fitness',
      'wave-pulse',
      'weight-hanging',
      'whistle',
      'wreath-laurel',
    ],
    label: 'Sports + Fitness',
  },
  'text-formatting': {
    icons: [
      'align-center',
      'align-justify',
      'align-left',
      'align-right',
      'align-slash',
      'block-quote',
      'bold',
      'border-all',
      'border-bottom',
      'border-bottom-right',
      'border-center-h',
      'border-center-v',
      'border-inner',
      'border-left',
      'border-none',
      'border-outer',
      'border-right',
      'border-top',
      'border-top-left',
      'check',
      'check-double',
      'circle-check',
      'columns-3',
      'command',
      'file-dashed-line',
      'filter-circle-xmark',
      'filter-list',
      'filter-slash',
      'filters',
      'font',
      'font-case',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'hashtag-lock',
      'heading',
      'highlighter',
      'horizontal-rule',
      'i-cursor',
      'icons',
      'indent',
      'italic',
      'kerning',
      'line-columns',
      'line-height',
      'list',
      'list-check',
      'list-ol',
      'list-ul',
      'lock-a',
      'lock-hashtag',
      'outdent',
      'overline',
      'paragraph',
      'paragraph-left',
      'rectangle-list',
      'spell-check',
      'square-a-lock',
      'square-check',
      'square-list',
      'strikethrough',
      'subscript',
      'superscript',
      'symbols',
      'table',
      'table-cells',
      'table-cells-large',
      'table-columns',
      'table-layout',
      'table-list',
      'table-pivot',
      'table-rows',
      'text',
      'text-height',
      'text-size',
      'text-slash',
      'text-width',
      'underline',
    ],
    label: 'Text Formatting',
  },
  time: {
    icons: [
      'alarm-clock',
      'alarm-exclamation',
      'alarm-plus',
      'alarm-snooze',
      'bell',
      'bell-exclamation',
      'bell-plus',
      'bell-slash',
      'calendar',
      'calendar-arrow-down',
      'calendar-arrow-up',
      'calendar-check',
      'calendar-circle-exclamation',
      'calendar-circle-minus',
      'calendar-circle-plus',
      'calendar-circle-user',
      'calendar-clock',
      'calendar-day',
      'calendar-days',
      'calendar-exclamation',
      'calendar-heart',
      'calendar-image',
      'calendar-lines',
      'calendar-lines-pen',
      'calendar-minus',
      'calendar-pen',
      'calendar-plus',
      'calendar-range',
      'calendar-star',
      'calendar-week',
      'calendar-xmark',
      'calendars',
      'circle-calendar',
      'clock',
      'clock-desk',
      'clock-eight',
      'clock-eight-thirty',
      'clock-eleven',
      'clock-eleven-thirty',
      'clock-five',
      'clock-five-thirty',
      'clock-four-thirty',
      'clock-nine',
      'clock-nine-thirty',
      'clock-one',
      'clock-one-thirty',
      'clock-seven',
      'clock-seven-thirty',
      'clock-six',
      'clock-six-thirty',
      'clock-ten',
      'clock-ten-thirty',
      'clock-three',
      'clock-three-thirty',
      'clock-twelve',
      'clock-twelve-thirty',
      'clock-two',
      'clock-two-thirty',
      'flux-capacitor',
      'hourglass',
      'hourglass-clock',
      'hourglass-end',
      'hourglass-half',
      'hourglass-start',
      'house-day',
      'house-night',
      'reply-clock',
      'snooze',
      'stopwatch',
      'stopwatch-20',
      'timer',
      'trash-can-clock',
      'trash-clock',
      'watch',
      'watch-apple',
      'watch-calculator',
      'watch-smart',
    ],
    label: 'Time',
  },
  toggle: {
    icons: [
      'brightness',
      'brightness-low',
      'bullseye',
      'bullseye-arrow',
      'circle',
      'circle-check',
      'circle-dot',
      'dial',
      'dial-high',
      'dial-low',
      'dial-max',
      'dial-med',
      'dial-med-low',
      'dial-min',
      'dial-off',
      'keyboard-brightness',
      'keyboard-brightness-low',
      'location-crosshairs',
      'location-crosshairs-slash',
      'microphone',
      'microphone-slash',
      'plane-up',
      'plane-up-slash',
      'signal',
      'signal-bars',
      'signal-bars-fair',
      'signal-bars-good',
      'signal-bars-slash',
      'signal-bars-weak',
      'signal-fair',
      'signal-good',
      'signal-slash',
      'signal-strong',
      'signal-weak',
      'slider',
      'sliders-simple',
      'star',
      'star-half',
      'star-half-stroke',
      'toggle-large-off',
      'toggle-large-on',
      'toggle-off',
      'toggle-on',
      'wifi',
      'wifi-exclamation',
      'wifi-fair',
      'wifi-slash',
      'wifi-weak',
    ],
    label: 'Toggle',
  },
  transportation: {
    icons: [
      'accessible-icon',
      'baby-carriage',
      'bicycle',
      'bridge-suspension',
      'bus',
      'bus-simple',
      'cable-car',
      'car',
      'car-bolt',
      'car-building',
      'car-bump',
      'car-burst',
      'car-bus',
      'car-circle-bolt',
      'car-rear',
      'car-side',
      'car-side-bolt',
      'car-tilt',
      'car-tunnel',
      'cars',
      'cart-shopping',
      'drone',
      'drone-front',
      'ferry',
      'flux-capacitor',
      'helicopter',
      'horse',
      'horse-saddle',
      'jet-fighter',
      'jet-fighter-up',
      'moped',
      'motorcycle',
      'mound',
      'paper-plane',
      'pegasus',
      'person-ski-lift',
      'person-snowmobiling',
      'plane',
      'plane-engines',
      'plane-prop',
      'plane-slash',
      'plane-tail',
      'plane-up',
      'road',
      'road-barrier',
      'road-spikes',
      'robot-astromech',
      'rocket',
      'rocket-launch',
      'rv',
      'sailboat',
      'seat-airline',
      'ship',
      'shuttle-space',
      'sleigh',
      'snowplow',
      'starfighter',
      'starfighter-twin-ion-engine',
      'starfighter-twin-ion-engine-advanced',
      'starship',
      'starship-freighter',
      'taxi',
      'taxi-bus',
      'tower-control',
      'tractor',
      'train',
      'train-subway',
      'train-subway-tunnel',
      'train-track',
      'train-tram',
      'train-tunnel',
      'tricycle',
      'tricycle-adult',
      'truck',
      'truck-arrow-right',
      'truck-bolt',
      'truck-container-empty',
      'truck-droplet',
      'truck-field',
      'truck-field-un',
      'truck-flatbed',
      'truck-front',
      'truck-medical',
      'truck-monster',
      'truck-pickup',
      'truck-plane',
      'truck-plow',
      'truck-tow',
      'ufo',
      'ufo-beam',
      'van-shuttle',
      'wheelchair',
      'wheelchair-move',
    ],
    label: 'Transportation',
  },
  'travel-hotel': {
    icons: [
      'air-conditioner',
      'alarm-clock',
      'alarm-snooze',
      'archway',
      'baby-carriage',
      'ban-smoking',
      'bath',
      'bed',
      'bed-bunk',
      'bed-empty',
      'bell-concierge',
      'book-atlas',
      'briefcase',
      'bus',
      'bus-simple',
      'cable-car',
      'cactus',
      'car',
      'car-building',
      'car-bus',
      'car-garage',
      'caravan',
      'caravan-simple',
      'cars',
      'cart-flatbed-suitcase',
      'dice',
      'dice-five',
      'door-closed',
      'door-open',
      'dryer',
      'dryer-heat',
      'dumbbell',
      'earth-africa',
      'earth-americas',
      'earth-asia',
      'earth-europe',
      'earth-oceania',
      'elevator',
      'escalator',
      'fan-table',
      'fireplace',
      'flux-capacitor',
      'fork-knife',
      'heat',
      'horse-saddle',
      'hot-tub-person',
      'hotel',
      'infinity',
      'island-tropical',
      'key',
      'kitchen-set',
      'lamp-desk',
      'map',
      'map-location',
      'map-location-dot',
      'martini-glass',
      'martini-glass-citrus',
      'martini-glass-empty',
      'microwave',
      'monument',
      'moped',
      'mountain-city',
      'mug-saucer',
      'outlet',
      'oven',
      'passport',
      'paw-simple',
      'person-seat',
      'person-seat-reclined',
      'person-swimming',
      'person-walking-luggage',
      'phone-rotary',
      'pineapple',
      'plane',
      'plane-arrival',
      'plane-circle-check',
      'plane-circle-exclamation',
      'plane-circle-xmark',
      'plane-departure',
      'plane-lock',
      'plane-prop',
      'plane-slash',
      'plane-tail',
      'plane-up',
      'plane-up-slash',
      'plate-utensils',
      'refrigerator',
      'restroom-simple',
      'ring-diamond',
      'rings-wedding',
      'rv',
      'seat-airline',
      'shower',
      'slot-machine',
      'smoking',
      'snooze',
      'snowflake',
      'spa',
      'stairs',
      'suitcase',
      'suitcase-rolling',
      'taxi',
      'taxi-bus',
      'ticket-airline',
      'tickets-airline',
      'toilet',
      'toilet-paper',
      'toilet-paper-blank-under',
      'toilet-paper-check',
      'toilet-paper-under',
      'toilet-paper-under-slash',
      'toilet-paper-xmark',
      'tower-control',
      'train-subway-tunnel',
      'train-tram',
      'tree-city',
      'tree-palm',
      'tv',
      'tv-retro',
      'umbrella-beach',
      'user-chef',
      'user-pilot',
      'user-pilot-tie',
      'utensils',
      'vacuum',
      'van-shuttle',
      'wagon-covered',
      'washing-machine',
      'water-ladder',
      'wheelchair',
      'wheelchair-move',
      'wifi',
      'wifi-slash',
      'wine-glass',
      'wine-glass-empty',
    ],
    label: 'Travel + Hotel',
  },
  'users-people': {
    icons: [
      'accessible-icon',
      'address-book',
      'address-card',
      'angel',
      'arrows-down-to-people',
      'baby',
      'bed',
      'book-user',
      'chalkboard-user',
      'chart-user',
      'child',
      'child-dress',
      'child-reaching',
      'children',
      'circle-user',
      'clipboard-user',
      'elevator',
      'face-frown',
      'face-meh',
      'face-smile',
      'family',
      'family-dress',
      'family-pants',
      'file-user',
      'folder-user',
      'head-side',
      'head-side-brain',
      'head-side-cough',
      'head-side-cough-slash',
      'head-side-goggles',
      'head-side-headphones',
      'head-side-heart',
      'head-side-mask',
      'head-side-medical',
      'head-side-virus',
      'hospital-user',
      'hot-tub-person',
      'house-chimney-user',
      'house-person-leave',
      'house-person-return',
      'house-user',
      'id-badge',
      'id-card',
      'id-card-clip',
      'image-polaroid-user',
      'image-portrait',
      'image-user',
      'images-user',
      'mars-and-venus-burst',
      'people',
      'people-arrows',
      'people-carry-box',
      'people-dress',
      'people-dress-simple',
      'people-group',
      'people-line',
      'people-pants',
      'people-pants-simple',
      'people-pulling',
      'people-robbery',
      'people-roof',
      'people-simple',
      'person',
      'person-arrow-down-to-line',
      'person-arrow-up-from-line',
      'person-biking',
      'person-biking-mountain',
      'person-booth',
      'person-breastfeeding',
      'person-burst',
      'person-cane',
      'person-carry-box',
      'person-chalkboard',
      'person-circle-check',
      'person-circle-exclamation',
      'person-circle-minus',
      'person-circle-plus',
      'person-circle-question',
      'person-circle-xmark',
      'person-digging',
      'person-dolly',
      'person-dolly-empty',
      'person-dots-from-line',
      'person-dress',
      'person-dress-burst',
      'person-dress-simple',
      'person-drowning',
      'person-falling',
      'person-falling-burst',
      'person-from-portal',
      'person-half-dress',
      'person-harassing',
      'person-hiking',
      'person-military-pointing',
      'person-military-rifle',
      'person-military-to-person',
      'person-pinball',
      'person-praying',
      'person-pregnant',
      'person-rays',
      'person-rifle',
      'person-running',
      'person-seat',
      'person-seat-reclined',
      'person-shelter',
      'person-sign',
      'person-simple',
      'person-skating',
      'person-ski-jumping',
      'person-ski-lift',
      'person-skiing',
      'person-skiing-nordic',
      'person-sledding',
      'person-snowboarding',
      'person-snowmobiling',
      'person-swimming',
      'person-through-window',
      'person-to-door',
      'person-to-portal',
      'person-walking',
      'person-walking-arrow-loop-left',
      'person-walking-arrow-right',
      'person-walking-dashed-line-arrow-right',
      'person-walking-luggage',
      'person-walking-with-cane',
      'poll-people',
      'poo',
      'restroom',
      'restroom-simple',
      'screen-users',
      'skull',
      'square-person-confined',
      'square-user',
      'street-view',
      'user',
      'user-alien',
      'user-astronaut',
      'user-bounty-hunter',
      'user-check',
      'user-chef',
      'user-clock',
      'user-cowboy',
      'user-crown',
      'user-doctor',
      'user-doctor-hair',
      'user-doctor-hair-long',
      'user-doctor-message',
      'user-gear',
      'user-graduate',
      'user-group',
      'user-group-crown',
      'user-hair',
      'user-hair-buns',
      'user-hair-long',
      'user-hair-mullet',
      'user-headset',
      'user-helmet-safety',
      'user-injured',
      'user-large',
      'user-large-slash',
      'user-lock',
      'user-magnifying-glass',
      'user-minus',
      'user-music',
      'user-ninja',
      'user-nurse',
      'user-nurse-hair',
      'user-nurse-hair-long',
      'user-pen',
      'user-pilot',
      'user-pilot-tie',
      'user-plus',
      'user-police',
      'user-police-tie',
      'user-robot',
      'user-robot-xmarks',
      'user-secret',
      'user-shakespeare',
      'user-shield',
      'user-slash',
      'user-tag',
      'user-tie',
      'user-tie-hair',
      'user-tie-hair-long',
      'user-unlock',
      'user-visor',
      'user-vneck',
      'user-vneck-hair',
      'user-vneck-hair-long',
      'user-xmark',
      'users',
      'users-between-lines',
      'users-gear',
      'users-line',
      'users-medical',
      'users-rays',
      'users-rectangle',
      'users-slash',
      'users-viewfinder',
      'wheelchair',
      'wheelchair-move',
    ],
    label: 'Users + People',
  },
  weather: {
    icons: [
      'bolt',
      'bolt-lightning',
      'cloud',
      'cloud-bolt',
      'cloud-bolt-moon',
      'cloud-bolt-sun',
      'cloud-drizzle',
      'cloud-fog',
      'cloud-hail',
      'cloud-hail-mixed',
      'cloud-meatball',
      'cloud-moon',
      'cloud-moon-rain',
      'cloud-rain',
      'cloud-rainbow',
      'cloud-showers',
      'cloud-showers-heavy',
      'cloud-showers-water',
      'cloud-sleet',
      'cloud-snow',
      'cloud-sun',
      'cloud-sun-rain',
      'clouds',
      'clouds-moon',
      'clouds-sun',
      'droplet-degree',
      'droplet-percent',
      'eclipse',
      'fire-smoke',
      'heat',
      'house-tsunami',
      'house-water',
      'hurricane',
      'icicles',
      'meteor',
      'moon',
      'moon-cloud',
      'moon-over-sun',
      'moon-stars',
      'poo-storm',
      'rainbow',
      'raindrops',
      'smog',
      'smoke',
      'snow-blowing',
      'snowflake',
      'snowflake-droplets',
      'snowflakes',
      'sparkle',
      'sparkles',
      'stars',
      'sun',
      'sun-bright',
      'sun-cloud',
      'sun-dust',
      'sun-haze',
      'sun-plant-wilt',
      'sunrise',
      'sunset',
      'temperature-arrow-down',
      'temperature-arrow-up',
      'temperature-empty',
      'temperature-full',
      'temperature-half',
      'temperature-high',
      'temperature-list',
      'temperature-low',
      'temperature-quarter',
      'temperature-snow',
      'temperature-sun',
      'temperature-three-quarters',
      'tornado',
      'umbrella',
      'umbrella-simple',
      'volcano',
      'water',
      'water-arrow-down',
      'water-arrow-up',
      'wind',
      'wind-warning',
      'windsock',
    ],
    label: 'Weather',
  },
  writing: {
    icons: [
      'blog',
      'book',
      'book-arrow-right',
      'book-arrow-up',
      'book-bookmark',
      'book-circle-arrow-right',
      'book-circle-arrow-up',
      'book-copy',
      'book-font',
      'book-open-cover',
      'bookmark',
      'bookmark-slash',
      'box-archive',
      'circle-book-open',
      'circle-bookmark',
      'envelope',
      'envelope-open',
      'eraser',
      'file',
      'file-lines',
      'folder',
      'folder-open',
      'highlighter-line',
      'input-numeric',
      'input-pipe',
      'input-text',
      'keyboard',
      'memo',
      'memo-circle-check',
      'memo-circle-info',
      'memo-pad',
      'newspaper',
      'notdef',
      'note',
      'note-sticky',
      'notebook',
      'notes',
      'paper-plane',
      'paperclip',
      'paperclip-vertical',
      'paragraph',
      'pen',
      'pen-circle',
      'pen-clip',
      'pen-clip-slash',
      'pen-fancy-slash',
      'pen-field',
      'pen-line',
      'pen-slash',
      'pen-swirl',
      'pen-to-square',
      'pencil',
      'pencil-mechanical',
      'pencil-slash',
      'quote-left',
      'quote-right',
      'quotes',
      'signature',
      'square-pen',
      'square-quote',
      'thumbtack',
      'typewriter',
    ],
    label: 'Writing',
  },
};

const categories: { label: string; icons: string[] }[] = Object.values(icons);

export default categories;
